export const futures = {
  en: {
    "futures.chart.entry": "Entry",
    "futures.chart.toolbar.chart_type": "Chart Type",
    "futures.chart.toolbar.indicators": "Indicators",
    "futures.chart.toolbar.drawings": "Drawings",
    "futures.chart.toolbar.more": "More",
    "futures.chart.toolbar.timezone_settings": "Timezone settings",
    "futures.chart.more_menu.pl_lines": "P&L Lines",
    "futures.chart.type_menu.chart_types": "Chart types",
    "futures.chart.type_menu.time_frames": "Time frames",
    "futures.chart.type_menu.settings": "Settings",
    "futures.chart.type_menu.enable_timer": "Enable timer",
    "futures.chart.type_menu.enable_autoscroll": "Enable autoscroll",
    "futures.chart.type_menu.enable_grid_snap": "Enable grid snap",
    "futures.chart.type_menu.custom_candle_colors": "Custom candle colors",
    "futures.chart.candle_colors.title": "Custom colors",
    "futures.chart.candle_colors.close": "Close",
    "futures.chart.candle_colors.uptrend": "Uptrend color",
    "futures.chart.candle_colors.downtrend": "Downtrend color",
    "futures.chart.candle_colors.use_default": "Use default colors",
    "futures.chart.candle_colors.apply": "Apply",
    "futures.chart.candle_colors.shadow_style": "Shadow style",
    "futures.chart.candle_colors.shadow_regular": "Regular",
    "futures.chart.candle_colors.shadow_thick": "Thick",
    "futures.chart.type.line": "Line",
    "futures.chart.type.candles": "Candles",
    "futures.chart.type.bars": "Bars",
    "futures.chart.type.heikin_ashi": "Heikin Ashi",
    "futures.chart.ohlc.open": "Open",
    "futures.chart.ohlc.close": "Close",
    "futures.chart.ohlc.high": "High",
    "futures.chart.ohlc.low": "Low",
    "futures.chart.zoom.visible_range": "Visible range",
    "futures.chart.resize": "Drag to resize",
    "futures.chart.scroll_to_end": "Scroll to the latest bar",
    "futures.chart.timezone.title": "Time zone",
    "futures.chart.timezone.description": "The time zone of your profile: the chart, its clock and all times on the platform use it.",
    "futures.chart.timezone.your_location": "Your location",
    "futures.chart.timezone.search": "Search",
    "futures.chart.timezone.not_found": "Nothing found",
    "futures.chart.timezone.close": "Close",
    "futures.chart.indicators.tab_current": "Current",
    "futures.chart.indicators.tab_all": "All",
    "futures.chart.indicators.tab_favorites": "Favorites",
    "futures.chart.indicators.delete_all": "Delete all ({count})",
    "futures.chart.indicators.add_favorite": "Add to favorites",
    "futures.chart.indicators.remove_favorite": "Remove from favorites",
    "futures.chart.indicators.remove": "Remove",
    "futures.chart.indicators.hide": "Hide",
    "futures.chart.indicators.show": "Show",
    "futures.chart.indicators.settings": "Settings",
    "futures.chart.indicators.legend_collapse": "Collapse indicators",
    "futures.chart.indicators.legend_expand": "Show indicators",
    "futures.chart.indicators.header_hide": "Hide title",
    "futures.chart.indicators.header_show": "Show title",
    "futures.chart.indicators.pane_expand": "Expand",
    "futures.chart.indicators.pane_restore": "Restore size",
    "futures.chart.drawings.tab_current": "Current",
    "futures.chart.drawings.tab_all": "All",
    "futures.chart.drawings.delete_all": "Delete all ({count})",
    "futures.chart.drawings.remove": "Remove",
    "futures.chart.drawings.tool_horizontal_line": "Horizontal Line",
    "futures.chart.drawings.tool_vertical_line": "Vertical Line",
    "futures.chart.drawings.tool_ray": "Ray",
    "futures.chart.drawings.tool_trend_line": "Trend Line",
    "futures.chart.drawings.tool_rectangle": "Rectangle",
    "futures.chart.drawings.tool_fibonacci_retracement": "Fibonacci Retracement",
    "futures.chart.drawings.tool_fibonacci_fan": "Fibonacci Fan",
    "futures.chart.drawings.tool_parallel_channel": "Parallel Channel",
    "futures.chart.drawings.tool_andrews_pitchfork": "Andrew's Pitchfork",
    "futures.chart.drawing_toolbar.label": "Drawing toolbar",
    "futures.chart.drawing_toolbar.move": "Move the toolbar",
    "futures.chart.drawing_toolbar.clone": "Clone",
    "futures.chart.drawing_toolbar.settings": "Settings",
    "futures.chart.drawing_toolbar.lock": "Lock",
    "futures.chart.drawing_toolbar.unlock": "Unlock",
    "futures.chart.indicator_settings.close": "Close",
    "futures.chart.indicator_settings.tab_inputs": "Inputs",
    "futures.chart.indicator_settings.tab_styles": "Styles",
    "futures.chart.indicator_settings.remove": "Remove",
    "futures.chart.indicator_settings.cancel": "Cancel",
    "futures.chart.indicator_settings.save": "Save",
    "futures.chart.indicator_settings.line_color": "Line color",
    "futures.chart.indicator_settings.line_width": "Line width",
    "futures.chart.indicator_settings.line_style": "Line color and width",
    "futures.chart.indicator_settings.show": "Show",
    "futures.chart.indicator_settings.level": "Level",
    "futures.chart.indicator_settings.down_color": "falling",
    "futures.no-data": "No active trades",
    "futures.no-data.desc": "Place a trade to see it here.",
    "futures.order_book": "Order Book",
    "futures.price": "Price",
    "futures.size": "Size",
    "futures.total": "Total",
    "futures.cost": "Cost",
    "futures.isolated": "Isolated",
    "futures.limit": "Limit",
    "futures.market": "Market",
    "futures.instrument": "Instrument",
    "futures.order-type": "Order Type",
    "futures.avg_filled_price": "Avg. Filled Price",
    "futures.avg_filled_price-short": "Avg. Price",
    "futures.status-filled": "Filled",
    "futures.status-cancelled": "Cancelled",
    "futures.order-price": "Order Price",
    "futures.order-quantity": "Filled/Order Quantity",
    "futures.order-type-short": "Type",
    "futures.order-price-short": "Price",
    "futures.order-value-short": "Value",
    "futures.order-quantity-short": "Filled/Qty",
    "futures.order-value": "Order Value",
    "futures.order-id": "Order ID",
    "futures.reduce-only": "Reduce-Only",
    "futures.order-action": "Action",
    "futures.available_balance": "Available Balance",
    "futures.long": "Long",
    "futures.short": "Short",
    "futures.open-long": "Long",
    "futures.open-short": "Short",
    "futures.liq_price": "Liq Price",
    "futures.quantity": "Quantity",
    "futures.max": "Max",
    "futures.adjust_leverage": "Adjust Leverage",
    "futures.leverage": "Leverage",
    "futures.leverage_warn":
      "* Selecting higher leverage such as [10x] increases your liquidation\n" +
      "              risk. Always manage your risk levels. See our help article for more\n" +
      "              information.",

    "futures.positions": "Positions",
    "futures.open_orders": "Open Orders",
    "futures.order_history": "Order History",
    "futures.position_history": "Position History",
    "futures.open_trades": "Open Trades",
    "futures.closed_trades": "Closed Trades",
    "futures.symbol": "Symbol",
    "futures.side": "Side",
    "futures.entry_price": "Entry Price",
    "futures.exit_price": "Exit Price",
    "futures.margin": "Margin",
    "futures.pnl_roi": "PnL (ROI %)",
    "futures.close_all_positions": "Close all positions",
    "futures.perp": "Perp",
    "futures.close": "Close",
    "futures.add": "Add",
    "futures.share": "P&L Share",
    "futures.copy": "Copy",
    "futures.save": "Save",
    "futures.buy": "Buy",
    "futures.sell": "Sell",
    "futures.modal.buy": "Buy",
    "futures.modal.sell": "Sell",
    "futures.email": "Email",
    "futures.telegram": "Telegram",
    "futures.more": "More",
    "futures.perpetual": "Perpetual",
    "futures.time": "Time",
    "futures.type": "Type",
    "futures.amount": "Amount",
    "futures.cancel_all": "Cancel all",
    "futures.cancel": "Cancel",
    "futures.executed": "Executed",
    "futures.status": "Status",
    "futures.closing_pnl": "Closing PNL",
    "futures.pair": "Pair",
    "futures.close_price": "Close Price",
    "futures.opened": "Opened",
    "futures.closed": "Closed",
    "futures.contracts": "Contracts",
    "futures.unrealized_pnl": "Unrealized P&L (ROI)",
    "futures.unrealized_pnl_short": "Unreal. P&L (ROI)",
    "futures.realized_pnl": "Realized P&L (ROI)",
    "futures.value": "Value",
    "futures.settings": "TP/SL Settings",
    "futures.direction": "Direction",
    "futures.direction_short": "Dir.",
    "futures.quality": "Qty",
    "futures.order_time": "Order Time",
    "futures.order_time-short": "Opened",
    "futures.close_time": "Close Time",
    "futures.realized": "Realized P&L",
    "futures.fees": "Fees",
    "futures.details": "Details",
    "futures.hide_other_symbols": "Hide Other Symbols",
    "futures.order_opened": "Order Opened",
    "futures.order_success": "Your order has been successfully placed!",
    "futures.position_opened": "Position Opened",
    "futures.position_success": "Your position has been successfully opened!",
    "futures.order_closed": "Order Closed",
    "futures.order_close_success": "Your order has been successfully closed!",
    "futures.position_closed": "Position Closed",
    "futures.position_close_success":
      "Your position has been successfully closed!",
    "futures.change_24h": "24h Change",
    "futures.open_profit_loss": "Open Profit/Loss",
    "futures.mark_price": "Mark Price",
    "futures.high_24h": "24h High",
    "futures.low_24h": "24h Low",
    "futures.quantity_24h": "24H Quantity (USDT)",
    "futures.total_24h": "24H Total",
    "futures.chart": "Chart",
    "futures.tp_sl.advanced": "Advanced",
    "futures.tp_sl.take_profit": "Take Profit",
    "futures.tp_sl.stop_loss": "Stop Loss",
    "futures.tp_sl.trigger_price": "Trigger Price",
    "futures.tp_sl.pnl": "PnL",
    "futures.tp_sl.short_label": "Hide Other Symbols",

    "futures.tp_sl.tp_description":
      "When the Mark Price reaches {price} USDT, it will trigger a Limit order, and the estimated PnL will be {pnl} USDT (ROI: {roi}%).",

    "futures.tp_sl.sl_description":
      "When the Mark Price reaches {price} USDT, it will trigger a Market order, and the estimated PnL will be {pnl} USDT (ROI: {roi}%).",

    "futures.share.description": ["Trade", "Like a Pro with", "Binify"],
    "futures.share.default_trader": "Binify Trader",
    "futures.entire_position": "Entire Position",
    "futures.partial_position": "Partial Position",
    "futures.add_tp_sl": "Add TP/SL",
    "futures.last_traded_price": "Last Traded Price",
    "futures.tp_by_roi": "TP (by ROI)",
    "futures.sl_by_roi": "SL (by ROI)",
    "futures.market_price": "Market Price",
    "futures.limit_price": "Limit Price",
    "futures.slippage_limit": "Slippage Limit",
    "futures.best_bid_ask": "Best Bid/Ask",
    "futures.close_size_quantity": "Close Size (Quantity)",
    "futures.size_percentage": "Size Percentage",
    "futures.exit_at_market": "Exit at Market",
    "futures.buy_profit": "Buy Profit",
    "futures.sell_profit": "Sell Profit",

    "futures.validation.invalid_cost": "Cost must be greater than 0",
    "futures.validation.cost_required": "Please enter a cost",
    "futures.validation.cost_min": "Minimum cost is {min}",
    "futures.validation.wager_min": "Minimum wager is {min}",
    "futures.validation.insufficient_balance": "Insufficient balance",
    "futures.new_validation_tp_sl.error_title": "Error placing trade",
    "futures.new_validation_tp_sl.sl_over_limit_percent": "Stop Loss cannot exceed 100% of your wager",
    "futures.new_validation_tp_sl.sl_over_limit_dollar": "Stop Loss cannot be greater than your wager amount",
    "futures.new_validation_tp_sl.tp_out_of_range": "Take Profit must be between {min} and {max}",

    "futures.onboarding.closeLabel": "Close onboarding",
    "futures.onboarding.step1.title": "Account Preferences",
    "futures.onboarding.step1.description":
      "Please select your country / region and preferred platform language to continue.",
    "futures.onboarding.step1.countryLabel": "Country / Region",
    "futures.onboarding.step1.countryValue": "Ukraine",
    "futures.onboarding.step1.languageLabel": "Platform language",
    "futures.onboarding.step1.countryPlaceholder": "Select your country",
    "futures.onboarding.step1.languageValue": "Ukrainian",
    "futures.onboarding.step1.note":
      "You can change these settings later in your profile.",
    "futures.onboarding.step1.confirm": "Confirm",
    "futures.onboarding.step2.back": "Back",
    "futures.onboarding.step2.title": "Good luck with your trading!",
    "futures.onboarding.step2.description":
      "Everything you need to start trading successfully on",
    "futures.onboarding.step2.guideTitle": "Study the introductory guide",
    "futures.onboarding.step2.guideDescription":
      "Learn the basics and start with confidence.",
    "futures.onboarding.step2.tutorial": "Tutorial",
    "futures.onboarding.step2.depositTitle": "Investment for real profit",
    "futures.onboarding.step2.depositDescription":
      "Fund your account and start trading in minutes.",
    "futures.onboarding.step2.depositButton": "Deposit",
    "futures.onboarding.step2.startTitle": "Go to the platform right now!",
    "futures.onboarding.step2.startDescription":
      "Explore the platform and start trading.",
    "futures.onboarding.step2.startButton": "Start",
    "futures.onboarding.step2.footer": "Ready to trade smarter. Trade on",

    "futures.onboarding.trading_chart.title": "Trading Chart",
    "futures.onboarding.trading_chart.description":
      "The chart shows how the asset price changes in real time. Use it to analyze the market and find trading opportunities.",
    "futures.onboarding.asset_selection.title": "Asset Selection",
    "futures.onboarding.asset_selection.description":
      "Choose the asset you want to trade from the list of available markets.",
    "futures.onboarding.available_assets.title": "Available Assets",
    "futures.onboarding.available_assets.description":
      "Browse all available trading pairs and choose the asset you want to trade.",
    "futures.onboarding.trading_panel.title": "Trading Panel",
    "futures.onboarding.trading_panel.description":
      "This is the trading panel where you can create and manage your trades.",
    "futures.onboarding.trading_panel_details.description":
      "Configure your order type, price, cost, leverage, and TP/SL settings before opening a position.",
    "futures.onboarding.limit_order.title": "Order Type",
    "futures.onboarding.limit_order.description":
      "Limit Order will be placed in Open Orders and will only open when the selected price is reached.",
    "futures.onboarding.market_order.title": "Order Type",
    "futures.onboarding.market_order.description":
      "Market Order opens immediately at the current price.",
    "futures.onboarding.position_size.title": "Position Size",
    "futures.onboarding.position_size.description":
      "Enter the amount you want to use for your trade.",
    "futures.onboarding.leverage.title": "Leverage",
    "futures.onboarding.leverage.description":
      "Leverage allows you to open larger positions using less margin.",
    "futures.onboarding.take_profit_stop_loss.title": "Take Profit & Stop Loss",
    "futures.onboarding.take_profit_stop_loss.description":
      "Set target profit and maximum loss levels to manage your position automatically.",
    "futures.onboarding.open_position.title": "Open Position",
    "futures.onboarding.open_position.description":
      "Long profits from rising prices. Short profits from falling prices. Choose a direction and open your position.",
    "futures.onboarding.open_orders.title": "Open Orders",
    "futures.onboarding.open_orders.description":
      "Open Orders — pending orders waiting to be executed.",
    "futures.onboarding.position_opened.title": "Position Opened",
    "futures.onboarding.position_opened.description":
      "Your position is now active. Track your PnL, Entry Price, Position Size, and Liquidation Price in the Positions section.",
    "futures.onboarding.positions.title": "Position",
    "futures.onboarding.positions.description":
      "Positions — active positions currently open.",
    "futures.onboarding.order_history.title": "Order History",
    "futures.onboarding.order_history.description":
      "Order History — all placed and executed orders.",
    "futures.onboarding.position_history.title": "Position History",
    "futures.onboarding.position_history.description":
      "Position History — all closed positions and their results.",
    "futures.onboarding.manage_position.title": "Manage Position",
    "futures.onboarding.manage_position.description":
      "You can edit Take Profit and Stop Loss settings or close the position at any time.",

    "futures.all_markets": "All markets",
    "futures.all_instruments": "All instruments",
    "futures.close_all": "Close all",
    "futures.spot_only": "Spot only",
    "futures.perpetual_only": "Perpetual only",
    "futures.expired_only": "Expired only",
    "futures.customization": "Customization",
    "futures.actions": "Actions",
    "futures.liquidation": "Liquidation",
    "futures.partial_close": "Partial Close",
    "futures.instrument_filter": "Instrument filter",
    "futures.my_position": "My Position",
    "futures.community": "Community",
    "futures.community.public_feed": "Public Feed",
    "futures.community.leaderboard": "Leaderboard",
    "futures.community.best_trades": "Best Trades",
    "futures.community.username": "Username",
    "futures.community.user": "User",
    "futures.community.rank": "Rank",
    "futures.community.trade": "Trade",
    "futures.community.trades": "Trades",
    "futures.community.favorite_asset": "Favorite Asset",
    "futures.community.wager": "Wager",
    "futures.community.total_wagered": "Total Wagered",
    "futures.community.biggest_win": "Biggest Win",
    "futures.community.total_profit": "Total Profit",
    "futures.community.leverage": "Leverage",
    "futures.community.entry": "Entry",
    "futures.community.exit": "Exit",
    "futures.community.profit_loss": "Profit / Loss",
    "futures.community.profit": "Profit",
    "futures.community.multiplier": "Multiplier",
    "futures.community.date": "Date",
    "futures.community.range": "Time range",
    "futures.community.range.1d": "1D",
    "futures.community.range.1w": "1W",
    "futures.community.range.1m": "1M",
    "futures.community.range.all": "All time",
    "futures.tp_sl.column": "TP/SL",
    "futures.liquidation_price": "Liquidation Price",
    "futures.mobile_trade.close": "Close",
    "futures.mobile_trade.wager": "Wager",
    "futures.mobile_trade.place_trade": "Place Trade",
    "futures.mobile_trade.placing": "Placing...",
    "futures.mobile_trade.fees_note": "Binify fees vary based upon the amount of leverage used. For a full breakdown,",
    "futures.mobile_trade.fees_link": "click here",
    "futures.mobile_trade.save_risk": "Save Risk Settings",
    "futures.mobile_trade.wager_amount": "Wager Amount",
    "futures.trade_form.wager_leverage": "Wager x Leverage",
    "futures.trade_form.risk_settings": "Risk Settings",
    "futures.trade_form.risk_mode": "Risk value mode",
    "futures.trade_form.view_fees": "View Binify fees",
    "futures.trade_modals.dont_ask_again": "Don’t ask again",
    "futures.trade_modals.close": "Close",
    "futures.cash_out.title": "Cash out this trade?",
    "futures.cash_out.text": "A market order will close this trade. The resulting profit or loss will be reflected in your account balance.",
    "futures.cash_out.confirm": "Cash out trade",
    "futures.close_all_modal.title": "Close all open trades?",
    "futures.close_all_modal.text": "This will place market orders to close your open trades. Any resulting profit or loss will be reflected in your account balance.",
    "futures.close_all_modal.confirm": "Close all trades",
    "futures.close_all_modal.cancel": "Keep trades open",
    "futures.partial_close_modal.title": "Close Trade",
    "futures.partial_close_modal.select_amount": "Select amount to close",
    "futures.partial_close_modal.hint": "Please confirm your sell order at market price",
    "futures.partial_close_modal.wager_leverage": "Wager x leverage",
    "futures.partial_close_modal.placed_on": "Placed On",
    "futures.partial_close_modal.warning": "Please confirm your sell order at market price. Once confirmed, this action cannot be undone.",
    "futures.partial_close_modal.close_all": "Close All",
    "futures.partial_close_modal.too_small": "This amount is too small to close. Choose a higher percentage or close the trade fully.",
    "futures.fees_modal.open_fee": "Open Fee",
    "futures.fees_modal.roi_fee": "ROI Fee",
    "futures.fees_modal.open_description": "A 1% fee charged only on your wager amount, not on the leveraged total.",
    "futures.fees_modal.roi_description": "Set your wager, your leverage, and how much the price moves. This is what you walk away with.",
    "futures.fees_modal.fee": "Fee",
    "futures.fees_modal.wager_size": "Wager Size",
    "futures.fees_modal.profit_loss": "Profit & Loss",
    "futures.fees_modal.multi": "Multi",
    "futures.fees_modal.price_move": "Price Move",
    "futures.fees_modal.max_profit_for": "Max Profit for",
    "futures.fees_modal.simple_title": "In simple terms",
    "futures.fees_modal.open_simple": "Binify offers one of the lowest opening fees in the industry. Unlike competing platforms that charge fees on your entire leveraged position, Binify only charges on your wager amount.",
    "futures.fees_modal.roi_simple": "ROI on Binify is influenced by several factors, including asset class, leverage, wager amount, and price movement. The further the price moves in your favor, the greater your potential return.",
    "futures.fees_modal.got_it": "Got it",
    "futures.trade_details.closed": "Closed",
    "futures.trade_details.direction": "Direction",
    "futures.trade_details.time_held": "Time Held",
    "futures.trade_details.placed_by": "Placed by",
    "futures.trade_details.trade_id": "Trade ID",
    "futures.trade_details.copy_id": "Copy trade ID",
    "futures.trade_details.share": "Share",
    "futures.trade_details.profit": "Profit",
    "futures.trade_details.up": "UP",
    "futures.trade_details.down": "DOWN",
    "futures.trade_details.date": "Date",
    "futures.trade_details.demo_account": "Demo account",
    "futures.trade_details.chart_no_data": "No chart data",
    "futures.trade_details.chart_error": "Couldn't load the chart",
    "futures.trade_details.chart_retry": "Retry",
    "futures.trader_profile.followers": "Followers",
    "futures.trader_profile.trades": "Trades",
    "futures.trader_profile.stats": "Stats",
    "futures.trader_profile.achievements": "Achievements",
    "futures.trader_profile.win_rate": "Win %",
    "futures.trader_profile.biggest_profit": "Biggest Profit",
    "futures.trader_profile.favorite_asset": "Favorite Asset",
    "futures.trader_profile.total_wagered": "Total Wagered",
    "futures.trader_profile.total_closed_trades": "Total Closed Trades",
    "futures.trader_profile.member_since": "Member since",
    "futures.trader_profile.follow": "Follow",
    "futures.toast.trade_opened": "Trade Opened",
    "futures.toast.trade_closed": "Trade Closed",
    "futures.toast.bet_liquidated": "Trade Liquidated",
    "futures.toast.your": "Your",
    "futures.toast.is_live": "trade is now live",
    "futures.toast.closed_for": "trade was closed for",
    "futures.toast.take_profit_hit": "Take Profit Hit",
    "futures.toast.stop_loss_hit": "Stop Loss Hit",
    "futures.toast.trade_partially_closed": "Trade Partially Closed",
    "futures.toast.of_your": "of your",
    "futures.toast.cashed_out": "You successfully cashed out",
    "futures.toast.partial_ending": "trade",
    "futures.trade_details.me": "Me",
    "futures.trader_profile.no_trades": "No trades yet",
    "futures.trade_details.opened": "Opened",
    "futures.trader_profile.no_achievements": "No achievements yet",
  },

  ru: {
    "futures.chart.entry": "Вход",
    "futures.chart.toolbar.chart_type": "Тип графика",
    "futures.chart.toolbar.indicators": "Индикаторы",
    "futures.chart.toolbar.drawings": "Рисование",
    "futures.chart.toolbar.more": "Ещё",
    "futures.chart.toolbar.timezone_settings": "Настройки часового пояса",
    "futures.chart.more_menu.pl_lines": "Линии P&L",
    "futures.chart.type_menu.chart_types": "Типы графиков",
    "futures.chart.type_menu.time_frames": "Таймфреймы",
    "futures.chart.type_menu.settings": "Настройки",
    "futures.chart.type_menu.enable_timer": "Таймер",
    "futures.chart.type_menu.enable_autoscroll": "Автопрокрутка",
    "futures.chart.type_menu.enable_grid_snap": "Привязка к сетке",
    "futures.chart.type_menu.custom_candle_colors": "Цвета свечей",
    "futures.chart.candle_colors.title": "Цвета свечей",
    "futures.chart.candle_colors.close": "Закрыть",
    "futures.chart.candle_colors.uptrend": "Цвет роста",
    "futures.chart.candle_colors.downtrend": "Цвет падения",
    "futures.chart.candle_colors.use_default": "Цвета по умолчанию",
    "futures.chart.candle_colors.apply": "Применить",
    "futures.chart.candle_colors.shadow_style": "Стиль теней",
    "futures.chart.candle_colors.shadow_regular": "Обычный",
    "futures.chart.candle_colors.shadow_thick": "Толстый",
    "futures.chart.type.line": "Линия",
    "futures.chart.type.candles": "Свечи",
    "futures.chart.type.bars": "Бары",
    "futures.chart.type.heikin_ashi": "Хейкен Аши",
    "futures.chart.ohlc.open": "Открытие",
    "futures.chart.ohlc.close": "Закрытие",
    "futures.chart.ohlc.high": "Максимум",
    "futures.chart.ohlc.low": "Минимум",
    "futures.chart.zoom.visible_range": "Видимый период",
    "futures.chart.resize": "Потяните, чтобы изменить высоту",
    "futures.chart.scroll_to_end": "К последней свече",
    "futures.chart.timezone.title": "Часовой пояс",
    "futures.chart.timezone.description": "Часовой пояс вашего профиля: по нему показываются график, часы и всё время на платформе.",
    "futures.chart.timezone.your_location": "Ваше местоположение",
    "futures.chart.timezone.search": "Поиск",
    "futures.chart.timezone.not_found": "Ничего не найдено",
    "futures.chart.timezone.close": "Закрыть",
    "futures.chart.indicators.tab_current": "Текущие",
    "futures.chart.indicators.tab_all": "Все",
    "futures.chart.indicators.tab_favorites": "Избранное",
    "futures.chart.indicators.delete_all": "Удалить все ({count})",
    "futures.chart.indicators.add_favorite": "Добавить в избранное",
    "futures.chart.indicators.remove_favorite": "Убрать из избранного",
    "futures.chart.indicators.remove": "Удалить",
    "futures.chart.indicators.hide": "Скрыть",
    "futures.chart.indicators.show": "Показать",
    "futures.chart.indicators.settings": "Настройки",
    "futures.chart.indicators.legend_collapse": "Свернуть индикаторы",
    "futures.chart.indicators.legend_expand": "Показать индикаторы",
    "futures.chart.indicators.header_hide": "Скрыть заголовок",
    "futures.chart.indicators.header_show": "Показать заголовок",
    "futures.chart.indicators.pane_expand": "Развернуть",
    "futures.chart.indicators.pane_restore": "Обычный размер",
    "futures.chart.drawings.tab_current": "Текущие",
    "futures.chart.drawings.tab_all": "Все",
    "futures.chart.drawings.delete_all": "Удалить все ({count})",
    "futures.chart.drawings.remove": "Удалить",
    "futures.chart.drawings.tool_horizontal_line": "Горизонтальная линия",
    "futures.chart.drawings.tool_vertical_line": "Вертикальная линия",
    "futures.chart.drawings.tool_ray": "Луч",
    "futures.chart.drawings.tool_trend_line": "Трендовая линия",
    "futures.chart.drawings.tool_rectangle": "Прямоугольник",
    "futures.chart.drawings.tool_fibonacci_retracement": "Коррекция Фибоначчи",
    "futures.chart.drawings.tool_fibonacci_fan": "Веер Фибоначчи",
    "futures.chart.drawings.tool_parallel_channel": "Параллельный канал",
    "futures.chart.drawings.tool_andrews_pitchfork": "Вилы Эндрюса",
    "futures.chart.drawing_toolbar.label": "Панель рисунка",
    "futures.chart.drawing_toolbar.move": "Переместить панель",
    "futures.chart.drawing_toolbar.clone": "Клонировать",
    "futures.chart.drawing_toolbar.settings": "Настройки",
    "futures.chart.drawing_toolbar.lock": "Заблокировать",
    "futures.chart.drawing_toolbar.unlock": "Разблокировать",
    "futures.chart.indicator_settings.close": "Закрыть",
    "futures.chart.indicator_settings.tab_inputs": "Параметры",
    "futures.chart.indicator_settings.tab_styles": "Стиль",
    "futures.chart.indicator_settings.remove": "Удалить",
    "futures.chart.indicator_settings.cancel": "Отмена",
    "futures.chart.indicator_settings.save": "Сохранить",
    "futures.chart.indicator_settings.line_color": "Цвет линии",
    "futures.chart.indicator_settings.line_width": "Толщина линии",
    "futures.chart.indicator_settings.line_style": "Цвет и толщина линии",
    "futures.chart.indicator_settings.show": "Показать",
    "futures.chart.indicator_settings.level": "Уровень",
    "futures.chart.indicator_settings.down_color": "падение",
    "futures.no-data": "Нет активных сделок",
    "futures.no-data.desc": "Сделайте сделку, чтобы увидеть ее здесь.",
    "futures.order_book": "Книга ордеров",
    "futures.price": "Цена",
    "futures.size": "Size",
    "futures.total": "Сумма",
    "futures.cost": "Стоимость",
    "futures.isolated": "Изолированная",
    "futures.limit": "Лимит",
    "futures.market": "Рынок",
    "futures.instrument": "Инструмент",
    "futures.order-type": "Тип ордера",
    "futures.order-price": "Цена ордера",
    "futures.avg_filled_price": "Сред. цена исполнения",
    "futures.avg_filled_price-short": "Сред. цена",
    "futures.status-filled": "Исполнено",
    "futures.status-cancelled": "Отменено",
    "futures.order-quantity": "Исполнено/Количество",
    "futures.order-type-short": "Тип",
    "futures.order-price-short": "Цена",
    "futures.order-value-short": "Стоимость",
    "futures.order-quantity-short": "Исп./Кол-во",
    "futures.order-value": "Стоимость ордера",
    "futures.order-id": "ID ордера",
    "futures.reduce-only": "Только уменьшение",
    "futures.order-action": "Действие",
    "futures.available_balance": "Доступный баланс",
    "futures.long": "Лонг",
    "futures.short": "Шорт",
    "futures.open-long": "Long",
    "futures.open-short": "Short",
    "futures.liq_price": "Цена ликвидации",
    "futures.quantity": "Количество",
    "futures.max": "Макс",
    "futures.adjust_leverage": "Настроить кредитное плечо",
    "futures.leverage": "Кредитное плечо",
    "futures.leverage_warn":
      "* Выбор высокого кредитного плеча, например [10x], увеличивает риск ликвидации.\n" +
      "              Всегда контролируйте уровень риска. Подробнее см. в нашей справке.",

    "futures.positions": "Позиции",
    "futures.open_orders": "Открытые ордера",
    "futures.order_history": "История открытых",
    "futures.position_history": "История позиций",
    "futures.open_trades": "Открытые сделки",
    "futures.closed_trades": "Закрытые сделки",
    "futures.symbol": "Символ",
    "futures.side": "Сторона",
    "futures.entry_price": "Цена входа",
    "futures.exit_price": "Цена выхода",
    "futures.margin": "Маржа",
    "futures.pnl_roi": "PnL (ROI %)",
    "futures.close_all_positions": "Закрыть все позиции",
    "futures.perp": "Перп",
    "futures.close": "Закрыть",
    "futures.time": "Время",
    "futures.type": "Тип",
    "futures.amount": "Сумма",
    "futures.cancel_all": "Отменить все",
    "futures.cancel": "Отменить",
    "futures.executed": "Исполнено",
    "futures.status": "Статус",
    "futures.closing_pnl": "Закрывающий PNL",
    "futures.pair": "Пара",
    "futures.close_price": "Цена закрытия",
    "futures.opened": "Открыто",
    "futures.closed": "Закрыто",
    "futures.add": "Добавить",
    "futures.share": "Поделиться P&L",
    "futures.copy": "Скопировать",
    "futures.save": "Сохранить",
    "futures.buy": "Купить",
    "futures.sell": "Продать",
    "futures.modal.buy": "Покупка",
    "futures.modal.sell": "Продажа",
    "futures.email": "Почта",
    "futures.telegram": "Телеграм",
    "futures.more": "Ещё",
    "futures.perpetual": "Бессрочные",
    "futures.contracts": "Контракты",
    "futures.unrealized_pnl": "Нереализованный P&L (ROI)",
    "futures.unrealized_pnl_short": "Нереал. PNL (ROI)",
    "futures.realized_pnl": "Реализованный P&L (ROI)",
    "futures.value": "Значение",
    "futures.settings": "Настройки TP/SL",
    "futures.direction": "Напр.",
    "futures.direction_short": "Напр.",
    "futures.quality": "Количество",
    "futures.order_time": "Время открытия",
    "futures.order_time-short": "Открыто",
    "futures.close_time": "Время закрытия",
    "futures.realized": "Реализованный P&L",
    "futures.fees": "Комиссии",
    "futures.details": "Детали",
    "futures.hide_other_symbols": "Скрыть другие символы",
    "futures.order_opened": "Ордер открыт",
    "futures.order_success": "Ваш ордер успешно размещен!",
    "futures.position_opened": "Позиция открыта",
    "futures.position_success": "Ваша позиция успешно открыта!",
    "futures.order_closed": "Ордер закрыт",
    "futures.order_close_success": "Ваш ордер был успешно закрыт!",
    "futures.position_closed": "Позиция закрыта",
    "futures.position_close_success": "Ваша позиция была успешно закрыта!",
    "futures.change_24h": "Изменение за 24 ч",
    "futures.open_profit_loss": "Открытая прибыль/убыток",
    "futures.mark_price": "Маркет-прайс",
    "futures.high_24h": "Макс. за 24 ч",
    "futures.low_24h": "Мин. за 24 ч",
    "futures.quantity_24h": "Объем за 24 ч (USDT)",
    "futures.total_24h": "Всего за 24 ч",
    "futures.chart": "График",
    "futures.tp_sl.advanced": "Расширенные",
    "futures.tp_sl.take_profit": "Тейк-профит",
    "futures.tp_sl.stop_loss": "Стоп-лосс",
    "futures.tp_sl.trigger_price": "Цена срабатывания",
    "futures.tp_sl.pnl": "Прибыль / Убыток",
    "futures.tp_sl.short_label": "Скрыть другие символы",

    "futures.tp_sl.tp_description":
      "Когда рыночная цена достигнет {price} USDT, будет создан лимитный ордер, а ожидаемый PnL составит {pnl} USDT (ROI: {roi}%).",

    "futures.tp_sl.sl_description":
      "Когда рыночная цена достигнет {price} USDT, будет создан рыночный ордер, а ожидаемый PnL составит {pnl} USDT (ROI: {roi}%).",

    "futures.share.description": ["Торгуй", "как профессионал с", "Binify"],
    "futures.share.default_trader": "Трейдер Binify",
    "futures.entire_position": "Вся позиция",
    "futures.partial_position": "Частичная позиция",
    "futures.add_tp_sl": "Добавить TP/SL",
    "futures.last_traded_price": "Последняя цена сделки",
    "futures.tp_by_roi": "TP (по ROI)",
    "futures.sl_by_roi": "SL (по ROI)",
    "futures.market_price": "Рыночная цена",
    "futures.limit_price": "Лимитная цена",
    "futures.slippage_limit": "Лимит проскальзывания",
    "futures.best_bid_ask": "Лучший Bid/Ask",
    "futures.close_size_quantity": "Размер закрытия (Количество)",
    "futures.size_percentage": "Процент размера",
    "futures.exit_at_market": "Выход по рынку",
    "futures.buy_profit": "Прибыль по лонгу",
    "futures.sell_profit": "Прибыль по шорту",

    "futures.validation.invalid_cost": "Стоимость должна быть больше 0",
    "futures.validation.cost_required": "Пожалуйста, введите стоимость",
    "futures.validation.cost_min": "Минимальная стоимость - {min}",
    "futures.validation.wager_min": "Минимальная ставка {min}",
    "futures.validation.insufficient_balance": "Недостаточно средств",
    "futures.new_validation_tp_sl.error_title": "Ошибка размещения сделки",
    "futures.new_validation_tp_sl.sl_over_limit_percent": "Стоп-лосс не может превышать 100% от суммы ставки",
    "futures.new_validation_tp_sl.sl_over_limit_dollar": "Стоп-лосс не может превышать сумму ставки",
    "futures.new_validation_tp_sl.tp_out_of_range": "Тейк-профит должен быть между {min} и {max}",

    "futures.onboarding.closeLabel": "Закрыть онбординг",
    "futures.onboarding.step1.title": "Настройки аккаунта",
    "futures.onboarding.step1.description":
      "Выберите страну / регион и предпочитаемый язык платформы, чтобы продолжить.",
    "futures.onboarding.step1.countryLabel": "Страна / Регион",
    "futures.onboarding.step1.countryValue": "Украина",
    "futures.onboarding.step1.languageLabel": "Язык платформы",
    "futures.onboarding.step1.countryPlaceholder": "Выберите свою страну",
    "futures.onboarding.step1.languageValue": "Украинский",
    "futures.onboarding.step1.note":
      "Вы можете изменить эти настройки позже в своем профиле.",
    "futures.onboarding.step1.confirm": "Подтвердить",
    "futures.onboarding.step2.back": "Назад",
    "futures.onboarding.step2.title": "Удачи в торговле!",
    "futures.onboarding.step2.description":
      "Все, что нужно для успешного старта торговли на",
    "futures.onboarding.step2.guideTitle": "Изучите вводный гайд",
    "futures.onboarding.step2.guideDescription":
      "Изучите основы и начните уверенно.",
    "futures.onboarding.step2.tutorial": "Обучение",
    "futures.onboarding.step2.depositTitle": "Инвестиция для реальной прибыли",
    "futures.onboarding.step2.depositDescription":
      "Пополните аккаунт и начните торговать за несколько минут.",
    "futures.onboarding.step2.depositButton": "Пополнить",
    "futures.onboarding.step2.startTitle": "Перейти на платформу прямо сейчас!",
    "futures.onboarding.step2.startDescription":
      "Изучите платформу и начните торговать.",
    "futures.onboarding.step2.startButton": "Начать",
    "futures.onboarding.step2.footer": "Готовы торговать умнее. Торгуйте на",

    "futures.onboarding.trading_chart.title": "Торговый график",
    "futures.onboarding.trading_chart.description":
      "График показывает изменение цены актива в реальном времени. Используйте его для анализа рынка и поиска торговых возможностей.",
    "futures.onboarding.asset_selection.title": "Выбор актива",
    "futures.onboarding.asset_selection.description":
      "Выберите актив, которым хотите торговать, из списка доступных рынков.",
    "futures.onboarding.available_assets.title": "Доступные активы",
    "futures.onboarding.available_assets.description":
      "Просмотрите все доступные торговые пары и выберите актив для торговли.",
    "futures.onboarding.trading_panel.title": "Торговая панель",
    "futures.onboarding.trading_panel.description":
      "Здесь вы можете создавать и управлять своими сделками.",
    "futures.onboarding.trading_panel_details.description":
      "Настройте тип ордера, цену, сумму, кредитное плечо и параметры TP/SL перед открытием позиции.",
    "futures.onboarding.limit_order.title": "Тип ордера",
    "futures.onboarding.limit_order.description":
      "Лимитный ордер будет размещён в открытых ордерах и исполнится только при достижении выбранной цены.",
    "futures.onboarding.market_order.title": "Тип ордера",
    "futures.onboarding.market_order.description":
      "Рыночный ордер открывается мгновенно по текущей рыночной цене.",
    "futures.onboarding.position_size.title": "Размер позиции",
    "futures.onboarding.position_size.description":
      "Введите сумму, которую хотите использовать для своей сделки.",
    "futures.onboarding.leverage.title": "Кредитное плечо",
    "futures.onboarding.leverage.description":
      "Кредитное плечо позволяет открывать более крупные позиции с меньшей маржой.",
    "futures.onboarding.take_profit_stop_loss.title": "Тейк-профит и Стоп-лосс",
    "futures.onboarding.take_profit_stop_loss.description":
      "Установите целевой уровень прибыли и максимальный уровень убытка для автоматического управления позицией.",
    "futures.onboarding.open_position.title": "Открытие позиции",
    "futures.onboarding.open_position.description":
      "Long приносит прибыль при росте цены. Short приносит прибыль при снижении цены. Выберите направление и откройте свою позицию.",
    "futures.onboarding.open_orders.title": "Открытые ордера",
    "futures.onboarding.open_orders.description":
      "Открытые ордера — это ордера, ожидающие исполнения.",
    "futures.onboarding.position_opened.title": "Позиция открыта",
    "futures.onboarding.position_opened.description":
      "Ваша позиция активна. Отслеживайте PnL, цену входа, размер позиции и цену ликвидации в разделе Позиции.",
    "futures.onboarding.positions.title": "Позиции",
    "futures.onboarding.positions.description":
      "Позиции — это все активные открытые позиции.",
    "futures.onboarding.order_history.title": "История ордеров",
    "futures.onboarding.order_history.description":
      "История ордеров — все размещённые и исполненные ордера.",
    "futures.onboarding.position_history.title": "История позиций",
    "futures.onboarding.position_history.description":
      "История позиций — все закрытые позиции и результаты их выполнения.",
    "futures.onboarding.manage_position.title": "Управление позицией",
    "futures.onboarding.manage_position.description":
      "Вы можете изменять настройки Тейк-профита и Стоп-лосса или закрыть позицию в любое время.",

    "futures.all_markets": "Все рынки",
    "futures.all_instruments": "Все инструменты",
    "futures.close_all": "Закрыть все",
    "futures.spot_only": "Только спот",
    "futures.perpetual_only": "Только бессрочные",
    "futures.expired_only": "Только истёкшие",
    "futures.customization": "Настройка",
    "futures.actions": "Действия",
    "futures.liquidation": "Ликвидация",
    "futures.partial_close": "Частичное закрытие",
    "futures.instrument_filter": "Фильтр инструментов",
    "futures.my_position": "Моя позиция",
    "futures.community": "Сообщество",
    "futures.community.public_feed": "Публичная лента",
    "futures.community.leaderboard": "Таблица лидеров",
    "futures.community.best_trades": "Лучшие сделки",
    "futures.community.username": "Имя пользователя",
    "futures.community.user": "Пользователь",
    "futures.community.rank": "Ранг",
    "futures.community.trade": "Сделка",
    "futures.community.trades": "Сделки",
    "futures.community.favorite_asset": "Любимый актив",
    "futures.community.wager": "Ставка",
    "futures.community.total_wagered": "Всего поставлено",
    "futures.community.biggest_win": "Лучший выигрыш",
    "futures.community.total_profit": "Общая прибыль",
    "futures.community.leverage": "Плечо",
    "futures.community.entry": "Вход",
    "futures.community.exit": "Выход",
    "futures.community.profit_loss": "Прибыль / Убыток",
    "futures.community.profit": "Прибыль",
    "futures.community.multiplier": "Множитель",
    "futures.community.date": "Дата",
    "futures.community.range": "Период",
    "futures.community.range.1d": "1D",
    "futures.community.range.1w": "1W",
    "futures.community.range.1m": "1M",
    "futures.community.range.all": "Всё время",
    "futures.tp_sl.column": "TP/SL",
    "futures.liquidation_price": "Цена ликвидации",
    "futures.mobile_trade.close": "Закрыть",
    "futures.mobile_trade.wager": "Ставка",
    "futures.mobile_trade.place_trade": "Открыть сделку",
    "futures.mobile_trade.placing": "Открытие...",
    "futures.mobile_trade.fees_note": "Комиссии Binify зависят от используемого кредитного плеча. Подробнее —",
    "futures.mobile_trade.fees_link": "нажмите здесь",
    "futures.mobile_trade.save_risk": "Сохранять настройки риска",
    "futures.mobile_trade.wager_amount": "Сумма ставки",
    "futures.trade_form.wager_leverage": "Ставка x плечо",
    "futures.trade_form.risk_settings": "Настройки риска",
    "futures.trade_form.risk_mode": "Режим значения риска",
    "futures.trade_form.view_fees": "Посмотреть комиссии Binify",
    "futures.trade_modals.dont_ask_again": "Больше не спрашивать",
    "futures.trade_modals.close": "Закрыть",
    "futures.cash_out.title": "Закрыть эту сделку?",
    "futures.cash_out.text": "Сделка будет закрыта рыночным ордером. Полученная прибыль или убыток отразится на балансе вашего счёта.",
    "futures.cash_out.confirm": "Закрыть сделку",
    "futures.close_all_modal.title": "Закрыть все открытые сделки?",
    "futures.close_all_modal.text": "Открытые сделки будут закрыты рыночными ордерами. Полученная прибыль или убыток отразится на балансе вашего счёта.",
    "futures.close_all_modal.confirm": "Закрыть все сделки",
    "futures.close_all_modal.cancel": "Оставить открытыми",
    "futures.partial_close_modal.title": "Закрыть сделку",
    "futures.partial_close_modal.select_amount": "Выберите сумму для закрытия",
    "futures.partial_close_modal.hint": "Подтвердите ордер на продажу по рыночной цене",
    "futures.partial_close_modal.wager_leverage": "Ставка x плечо",
    "futures.partial_close_modal.placed_on": "Открыта",
    "futures.partial_close_modal.warning": "Подтвердите ордер на продажу по рыночной цене. После подтверждения это действие нельзя отменить.",
    "futures.partial_close_modal.close_all": "Закрыть всё",
    "futures.partial_close_modal.too_small": "Эта сумма слишком мала для закрытия. Выберите больший процент или закройте сделку полностью.",
    "futures.fees_modal.open_fee": "Комиссия за открытие",
    "futures.fees_modal.roi_fee": "Комиссия ROI",
    "futures.fees_modal.open_description": "Комиссия 1% берётся только с суммы ставки, а не со всей суммы с плечом.",
    "futures.fees_modal.roi_description": "Укажите ставку, плечо и изменение цены. Вот сколько вы получите.",
    "futures.fees_modal.fee": "Комиссия",
    "futures.fees_modal.wager_size": "Размер ставки",
    "futures.fees_modal.profit_loss": "Прибыль и убыток",
    "futures.fees_modal.multi": "Множитель",
    "futures.fees_modal.price_move": "Изменение цены",
    "futures.fees_modal.max_profit_for": "Макс. прибыль для",
    "futures.fees_modal.simple_title": "Простыми словами",
    "futures.fees_modal.open_simple": "У Binify одна из самых низких комиссий за открытие в индустрии. В отличие от других платформ, которые берут комиссию со всей позиции с плечом, Binify берёт её только с суммы ставки.",
    "futures.fees_modal.roi_simple": "ROI на Binify зависит от нескольких факторов: класса актива, плеча, суммы ставки и изменения цены. Чем сильнее цена движется в вашу пользу, тем выше потенциальный доход.",
    "futures.fees_modal.got_it": "Понятно",
    "futures.trade_details.closed": "Закрыта",
    "futures.trade_details.direction": "Направление",
    "futures.trade_details.time_held": "Время удержания",
    "futures.trade_details.placed_by": "Открыл",
    "futures.trade_details.trade_id": "ID сделки",
    "futures.trade_details.copy_id": "Скопировать ID сделки",
    "futures.trade_details.share": "Поделиться",
    "futures.trade_details.profit": "Прибыль",
    "futures.trade_details.up": "ВВЕРХ",
    "futures.trade_details.down": "ВНИЗ",
    "futures.trade_details.date": "Дата",
    "futures.trade_details.demo_account": "Демо-счёт",
    "futures.trade_details.chart_no_data": "Нет данных для графика",
    "futures.trade_details.chart_error": "Не удалось загрузить график",
    "futures.trade_details.chart_retry": "Повторить",
    "futures.trader_profile.followers": "подписчиков",
    "futures.trader_profile.trades": "Сделки",
    "futures.trader_profile.stats": "Статистика",
    "futures.trader_profile.achievements": "Достижения",
    "futures.trader_profile.win_rate": "Побед %",
    "futures.trader_profile.biggest_profit": "Крупнейшая прибыль",
    "futures.trader_profile.favorite_asset": "Любимый актив",
    "futures.trader_profile.total_wagered": "Всего поставлено",
    "futures.trader_profile.total_closed_trades": "Закрытых сделок",
    "futures.trader_profile.member_since": "С нами с",
    "futures.trader_profile.follow": "Подписаться",
    "futures.toast.trade_opened": "Сделка открыта",
    "futures.toast.trade_closed": "Сделка закрыта",
    "futures.toast.bet_liquidated": "Сделка ликвидирована",
    "futures.toast.your": "Ваша сделка",
    "futures.toast.is_live": "открыта",
    "futures.toast.closed_for": "закрыта с результатом",
    "futures.toast.take_profit_hit": "Сработал тейк-профит",
    "futures.toast.stop_loss_hit": "Сработал стоп-лосс",
    "futures.toast.trade_partially_closed": "Сделка частично закрыта",
    "futures.toast.of_your": "вашей сделки",
    "futures.toast.cashed_out": "Вы успешно вывели",
    "futures.toast.partial_ending": " ",
    "futures.trade_details.me": "Я",
    "futures.trader_profile.no_trades": "Пока нет сделок",
    "futures.trade_details.opened": "Открыта",
    "futures.trader_profile.no_achievements": "Пока нет достижений",
  },

  es: {
    "futures.chart.entry": "Entrada",
    "futures.chart.toolbar.chart_type": "Tipo de gráfico",
    "futures.chart.toolbar.indicators": "Indicadores",
    "futures.chart.toolbar.drawings": "Dibujos",
    "futures.chart.toolbar.more": "Más",
    "futures.chart.toolbar.timezone_settings": "Configuración de zona horaria",
    "futures.chart.more_menu.pl_lines": "Líneas P&L",
    "futures.chart.type_menu.chart_types": "Tipos de gráficos",
    "futures.chart.type_menu.time_frames": "Marcos de tiempo",
    "futures.chart.type_menu.settings": "Configuración",
    "futures.chart.type_menu.enable_timer": "Habilitar temporizador",
    "futures.chart.type_menu.enable_autoscroll": "Habilitar desplazamiento automático",
    "futures.chart.type_menu.enable_grid_snap": "Habilitar ajuste a cuadrícula",
    "futures.chart.type_menu.custom_candle_colors": "Colores de velas",
    "futures.chart.candle_colors.title": "Colores personalizados",
    "futures.chart.candle_colors.close": "Cerrar",
    "futures.chart.candle_colors.uptrend": "Color alcista",
    "futures.chart.candle_colors.downtrend": "Color bajista",
    "futures.chart.candle_colors.use_default": "Usar colores predeterminados",
    "futures.chart.candle_colors.apply": "Aplicar",
    "futures.chart.candle_colors.shadow_style": "Estilo de sombra",
    "futures.chart.candle_colors.shadow_regular": "Normal",
    "futures.chart.candle_colors.shadow_thick": "Grueso",
    "futures.chart.type.line": "Línea",
    "futures.chart.type.candles": "Velas",
    "futures.chart.type.bars": "Barras",
    "futures.chart.type.heikin_ashi": "Heikin Ashi",
    "futures.chart.ohlc.open": "Apertura",
    "futures.chart.ohlc.close": "Cierre",
    "futures.chart.ohlc.high": "Máximo",
    "futures.chart.ohlc.low": "Mínimo",
    "futures.chart.zoom.visible_range": "Rango visible",
    "futures.chart.resize": "Arrastre para cambiar la altura",
    "futures.chart.scroll_to_end": "Ir a la última vela",
    "futures.chart.timezone.title": "Zona horaria",
    "futures.chart.timezone.description": "La zona horaria de su perfil: la usan el gráfico, su reloj y todas las horas de la plataforma.",
    "futures.chart.timezone.your_location": "Su ubicación",
    "futures.chart.timezone.search": "Buscar",
    "futures.chart.timezone.not_found": "No se encontró nada",
    "futures.chart.timezone.close": "Cerrar",
    "futures.chart.indicators.tab_current": "Actuales",
    "futures.chart.indicators.tab_all": "Todos",
    "futures.chart.indicators.tab_favorites": "Favoritos",
    "futures.chart.indicators.delete_all": "Eliminar todos ({count})",
    "futures.chart.indicators.add_favorite": "Añadir a favoritos",
    "futures.chart.indicators.remove_favorite": "Quitar de favoritos",
    "futures.chart.indicators.remove": "Eliminar",
    "futures.chart.indicators.hide": "Ocultar",
    "futures.chart.indicators.show": "Mostrar",
    "futures.chart.indicators.settings": "Ajustes",
    "futures.chart.indicators.legend_collapse": "Contraer indicadores",
    "futures.chart.indicators.legend_expand": "Mostrar indicadores",
    "futures.chart.indicators.header_hide": "Ocultar título",
    "futures.chart.indicators.header_show": "Mostrar título",
    "futures.chart.indicators.pane_expand": "Ampliar",
    "futures.chart.indicators.pane_restore": "Tamaño normal",
    "futures.chart.drawings.tab_current": "Actuales",
    "futures.chart.drawings.tab_all": "Todos",
    "futures.chart.drawings.delete_all": "Eliminar todos ({count})",
    "futures.chart.drawings.remove": "Eliminar",
    "futures.chart.drawings.tool_horizontal_line": "Línea horizontal",
    "futures.chart.drawings.tool_vertical_line": "Línea vertical",
    "futures.chart.drawings.tool_ray": "Rayo",
    "futures.chart.drawings.tool_trend_line": "Línea de tendencia",
    "futures.chart.drawings.tool_rectangle": "Rectángulo",
    "futures.chart.drawings.tool_fibonacci_retracement": "Retroceso de Fibonacci",
    "futures.chart.drawings.tool_fibonacci_fan": "Abanico de Fibonacci",
    "futures.chart.drawings.tool_parallel_channel": "Canal paralelo",
    "futures.chart.drawings.tool_andrews_pitchfork": "Horquilla de Andrews",
    "futures.chart.drawing_toolbar.label": "Barra del dibujo",
    "futures.chart.drawing_toolbar.move": "Mover la barra",
    "futures.chart.drawing_toolbar.clone": "Clonar",
    "futures.chart.drawing_toolbar.settings": "Ajustes",
    "futures.chart.drawing_toolbar.lock": "Bloquear",
    "futures.chart.drawing_toolbar.unlock": "Desbloquear",
    "futures.chart.indicator_settings.close": "Cerrar",
    "futures.chart.indicator_settings.tab_inputs": "Parámetros",
    "futures.chart.indicator_settings.tab_styles": "Estilo",
    "futures.chart.indicator_settings.remove": "Eliminar",
    "futures.chart.indicator_settings.cancel": "Cancelar",
    "futures.chart.indicator_settings.save": "Guardar",
    "futures.chart.indicator_settings.line_color": "Color de línea",
    "futures.chart.indicator_settings.line_width": "Grosor de línea",
    "futures.chart.indicator_settings.line_style": "Color y grosor de línea",
    "futures.chart.indicator_settings.show": "Mostrar",
    "futures.chart.indicator_settings.level": "Nivel",
    "futures.chart.indicator_settings.down_color": "bajada",
    "futures.no-data": "No hay operaciones activas",
    "futures.no-data.desc": "Realiza una operación para verla aquí.",
    "futures.order_book": "Libro de órdenes",
    "futures.price": "Precio",
    "futures.size": "Tamaño",
    "futures.total": "Total",
    "futures.cost": "Costo",
    "futures.isolated": "Aislado",
    "futures.limit": "Límite",
    "futures.market": "Mercado",
    "futures.instrument": "Instrumento",
    "futures.order-type": "Tipo de orden",
    "futures.order-price": "Precio",
    "futures.avg_filled_price": "Precio medio de ejecución",
    "futures.avg_filled_price-short": "Precio medio",
    "futures.status-filled": "Ejecutado",
    "futures.status-cancelled": "Cancelado",
    "futures.order-quantity": "Ejecutado/Cantidad",
    "futures.order-type-short": "Tipo",
    "futures.order-price-short": "Precio",
    "futures.order-value-short": "Valor",
    "futures.order-quantity-short": "Ejec./Cant.",
    "futures.order-value": "Valor de la orden",
    "futures.order-id": "ID de la orden",
    "futures.reduce-only": "Solo reducción",
    "futures.order-action": "Acción",
    "futures.available_balance": "Balance disponible",
    "futures.long": "Largo",
    "futures.short": "Corto",
    "futures.open-long": "Long",
    "futures.open-short": "Short",
    "futures.liq_price": "Precio liq.",
    "futures.quantity": "Cantidad",
    "futures.max": "Máx",
    "futures.adjust_leverage": "Ajustar apalancamiento",
    "futures.leverage": "Apalancamiento",
    "futures.leverage_warn":
      "* Seleccionar un apalancamiento más alto como [10x] incrementa su riesgo de liquidación.\n" +
      "              Gestione siempre sus niveles de riesgo. Consulte nuestro artículo de ayuda\n" +
      "              para más información.",

    "futures.positions": "Posiciones",
    "futures.open_orders": "Órdenes abiertas",
    "futures.order_history": "Historial de órdenes",
    "futures.position_history": "Historial de posiciones",
    "futures.open_trades": "Operaciones abiertas",
    "futures.closed_trades": "Operaciones cerradas",
    "futures.symbol": "Símbolo",
    "futures.side": "Lado",
    "futures.entry_price": "P. entrada",
    "futures.exit_price": "Precio de salida",
    "futures.margin": "Margen",
    "futures.pnl_roi": "PnL (ROI %)",
    "futures.close_all_positions": "Cerrar todas las posiciones",
    "futures.perp": "Perp",
    "futures.close": "Cerrar",
    "futures.add": "Añadir",
    "futures.share": "Compartir P&L",
    "futures.copy": "Copiar",
    "futures.save": "Guardar",
    "futures.buy": "Comprar",
    "futures.sell": "Vender",
    "futures.modal.buy": "Compra",
    "futures.modal.sell": "Venta",
    "futures.email": "Correo",
    "futures.telegram": "Telegram",
    "futures.more": "Más",
    "futures.perpetual": "Perpetuos",
    "futures.time": "Hora",
    "futures.type": "Tipo",
    "futures.amount": "Monto",
    "futures.cancel_all": "Cancelar todo",
    "futures.cancel": "Cancelar",
    "futures.executed": "Ejecutado",
    "futures.status": "Estado",
    "futures.closing_pnl": "PnL al cerrar",
    "futures.pair": "Par",
    "futures.close_price": "Precio de cierre",
    "futures.opened": "Abierto",
    "futures.closed": "Cerrado",
    "futures.contracts": "Contratos",
    "futures.unrealized_pnl": "P&L no realizado (ROI)",
    "futures.unrealized_pnl_short": "P&L no real. (ROI)",
    "futures.realized_pnl": "P&L realizado (ROI)",
    "futures.value": "Valor",
    "futures.settings": "Configuración de TP/SL",
    "futures.direction": "Dirección",
    "futures.direction_short": "Dir.",
    "futures.quality": "Cantidad",
    "futures.order_time": "Hora de apertura",
    "futures.order_time-short": "Apertura",
    "futures.close_time": "Hora de cierre",
    "futures.realized": "PnL realizado",
    "futures.fees": "Comisiones",
    "futures.details": "Detalles",
    "futures.hide_other_symbols": "Ocultar otros símbolos",
    "futures.order_opened": "Orden abierta",
    "futures.order_success": "¡Su orden ha sido colocada exitosamente!",
    "futures.position_opened": "Posición abierta",
    "futures.position_success": "¡Tu posición se ha abierto correctamente!",
    "futures.order_closed": "Orden cerrada",
    "futures.order_close_success": "Tu orden se ha cerrado correctamente.",
    "futures.position_closed": "Posición cerrada",
    "futures.position_close_success":
      "Tu posición se ha cerrado correctamente.",
    "futures.change_24h": "Cambio 24H",
    "futures.open_profit_loss": "Ganancia/Pérdida abierta",
    "futures.mark_price": "Precio de marca",
    "futures.high_24h": "Máximo 24H",
    "futures.low_24h": "Mínimo 24H",
    "futures.quantity_24h": "Cantidad 24H (USDT)",
    "futures.total_24h": "Total 24H",
    "futures.chart": "Gráfico",
    "futures.tp_sl.advanced": "Avanzado",
    "futures.tp_sl.take_profit": "Toma de ganancias",
    "futures.tp_sl.stop_loss": "Límite de pérdidas",
    "futures.tp_sl.trigger_price": "Precio de activación",
    "futures.tp_sl.pnl": "Ganancia / Pérdida",
    "futures.tp_sl.short_label": "Ocultar otros símbolos",

    "futures.tp_sl.tp_description":
      "Cuando el precio de mercado alcance {price} USDT, se activará una orden limitada y el PnL estimado será {pnl} USDT (ROI: {roi}%).",

    "futures.tp_sl.sl_description":
      "Cuando el precio de mercado alcance {price} USDT, se activará una orden de mercado y el PnL estimado será {pnl} USDT (ROI: {roi}%).",

    "futures.share.description": ["Opera", "como un profesional con", "Binify"],
    "futures.share.default_trader": "Trader de Binify",
    "futures.entire_position": "Posición completa",
    "futures.partial_position": "Posición parcial",
    "futures.add_tp_sl": "Añadir TP/SL",
    "futures.last_traded_price": "Último precio negociado",
    "futures.tp_by_roi": "TP (por ROI)",
    "futures.sl_by_roi": "SL (por ROI)",
    "futures.market_price": "Precio de mercado",
    "futures.limit_price": "Precio límite",
    "futures.slippage_limit": "Límite de deslizamiento",
    "futures.best_bid_ask": "Mejor Bid/Ask",
    "futures.close_size_quantity": "Tamaño de cierre (Cantidad)",
    "futures.size_percentage": "Porcentaje de tamaño",
    "futures.exit_at_market": "Salir al mercado",
    "futures.buy_profit": "Beneficio de compra (Long)",
    "futures.sell_profit": "Beneficio de venta (Short)",

    "futures.validation.invalid_cost": "El costo debe ser mayor que 0",
    "futures.validation.cost_required": "Por favor, introduzca un costo",
    "futures.validation.cost_min": "El coste mínimo es de {min}",
    "futures.validation.wager_min": "La apuesta mínima es de {min}",
    "futures.validation.insufficient_balance": "Saldo insuficiente",
    "futures.new_validation_tp_sl.error_title": "Error al colocar la operación",
    "futures.new_validation_tp_sl.sl_over_limit_percent": "El Stop Loss no puede superar el 100% de tu apuesta",
    "futures.new_validation_tp_sl.sl_over_limit_dollar": "El Stop Loss no puede ser mayor que el monto de tu apuesta",
    "futures.new_validation_tp_sl.tp_out_of_range": "El Take Profit debe estar entre {min} y {max}",

    "futures.onboarding.closeLabel": "Cerrar onboarding",
    "futures.onboarding.step1.title": "Preferencias de la cuenta",
    "futures.onboarding.step1.description":
      "Selecciona tu país / región y el idioma preferido de la plataforma para continuar.",
    "futures.onboarding.step1.countryLabel": "País / Región",
    "futures.onboarding.step1.countryValue": "Ucrania",
    "futures.onboarding.step1.languageLabel": "Idioma de la plataforma",
    "futures.onboarding.step1.countryPlaceholder": "Selecciona tu país",
    "futures.onboarding.step1.languageValue": "Ucraniano",
    "futures.onboarding.step1.note":
      "Puedes cambiar estos ajustes más tarde en tu perfil.",
    "futures.onboarding.step1.confirm": "Confirmar",
    "futures.onboarding.step2.back": "Atrás",
    "futures.onboarding.step2.title": "¡Buena suerte con tu trading!",
    "futures.onboarding.step2.description":
      "Todo lo que necesitas para empezar a operar con éxito en",
    "futures.onboarding.step2.guideTitle": "Estudia la guía introductoria",
    "futures.onboarding.step2.guideDescription":
      "Aprende los conceptos básicos y empieza con confianza.",
    "futures.onboarding.step2.tutorial": "Tutorial",
    "futures.onboarding.step2.depositTitle":
      "Inversión para obtener ganancias reales",
    "futures.onboarding.step2.depositDescription":
      "Deposita fondos en tu cuenta y empieza a operar en minutos.",
    "futures.onboarding.step2.depositButton": "Depositar",
    "futures.onboarding.step2.startTitle": "¡Ve a la plataforma ahora mismo!",
    "futures.onboarding.step2.startDescription":
      "Explora la plataforma y empieza a operar.",
    "futures.onboarding.step2.startButton": "Empezar",
    "futures.onboarding.step2.footer":
      "Listo para operar de forma más inteligente. Opera en",

    "futures.onboarding.trading_chart.title": "Gráfico de Trading",
    "futures.onboarding.trading_chart.description":
      "El gráfico muestra cómo cambia el precio del activo en tiempo real. Úselo para analizar el mercado y encontrar oportunidades de trading.",
    "futures.onboarding.asset_selection.title": "Selección de Activo",
    "futures.onboarding.asset_selection.description":
      "Seleccione el activo que desea operar de la lista de mercados disponibles.",
    "futures.onboarding.available_assets.title": "Activos Disponibles",
    "futures.onboarding.available_assets.description":
      "Explore todos los pares de trading disponibles y elija el activo que desea operar.",
    "futures.onboarding.trading_panel.title": "Panel de Trading",
    "futures.onboarding.trading_panel.description":
      "Este es el panel donde puede crear y gestionar sus operaciones.",
    "futures.onboarding.trading_panel_details.description":
      "Configura el tipo de orden, el precio, el coste, el apalancamiento y los ajustes de TP/SL antes de abrir una posición.",
    "futures.onboarding.limit_order.title": "Tipo de Orden",
    "futures.onboarding.limit_order.description":
      "La orden límite se colocará en Órdenes Abiertas y solo se ejecutará cuando se alcance el precio seleccionado.",
    "futures.onboarding.market_order.title": "Tipo de Orden",
    "futures.onboarding.market_order.description":
      "La orden de mercado se abre inmediatamente al precio actual.",
    "futures.onboarding.position_size.title": "Tamaño de la Posición",
    "futures.onboarding.position_size.description":
      "Introduzca la cantidad que desea utilizar para su operación.",
    "futures.onboarding.leverage.title": "Apalancamiento",
    "futures.onboarding.leverage.description":
      "El apalancamiento le permite abrir posiciones más grandes utilizando menos margen.",
    "futures.onboarding.take_profit_stop_loss.title": "Take Profit y Stop Loss",
    "futures.onboarding.take_profit_stop_loss.description":
      "Establezca niveles de beneficio objetivo y pérdida máxima para gestionar automáticamente su posición.",
    "futures.onboarding.open_position.title": "Abrir Posición",
    "futures.onboarding.open_position.description":
      "Long obtiene beneficios cuando el precio sube. Short obtiene beneficios cuando el precio baja. Elija una dirección y abra su posición.",
    "futures.onboarding.open_orders.title": "Órdenes Abiertas",
    "futures.onboarding.open_orders.description":
      "Las Órdenes Abiertas son órdenes pendientes de ejecución.",
    "futures.onboarding.position_opened.title": "Posición Abierta",
    "futures.onboarding.position_opened.description":
      "Su posición ya está activa. Controle su PnL, Precio de Entrada, Tamaño de Posición y Precio de Liquidación en la sección Posiciones.",
    "futures.onboarding.positions.title": "Posiciones",
    "futures.onboarding.positions.description":
      "Posiciones: todas las posiciones activas actualmente abiertas.",
    "futures.onboarding.order_history.title": "Historial de Órdenes",
    "futures.onboarding.order_history.description":
      "Historial de Órdenes: todas las órdenes realizadas y ejecutadas.",
    "futures.onboarding.position_history.title": "Historial de Posiciones",
    "futures.onboarding.position_history.description":
      "Historial de Posiciones: todas las posiciones cerradas y sus resultados.",
    "futures.onboarding.manage_position.title": "Gestionar Posición",
    "futures.onboarding.manage_position.description":
      "Puede modificar la configuración de Take Profit y Stop Loss o cerrar la posición en cualquier momento.",

    "futures.all_markets": "Todos los mercados",
    "futures.all_instruments": "Todos los instrumentos",
    "futures.close_all": "Cerrar todo",
    "futures.spot_only": "Solo spot",
    "futures.perpetual_only": "Solo perpetuos",
    "futures.expired_only": "Solo vencidos",
    "futures.customization": "Personalización",
    "futures.actions": "Acciones",
    "futures.liquidation": "Liquidación",
    "futures.partial_close": "Cierre parcial",
    "futures.instrument_filter": "Filtro de instrumentos",
    "futures.my_position": "Mi posición",
    "futures.community": "Comunidad",
    "futures.community.public_feed": "Feed público",
    "futures.community.leaderboard": "Clasificación",
    "futures.community.best_trades": "Mejores operaciones",
    "futures.community.username": "Usuario",
    "futures.community.user": "Usuario",
    "futures.community.rank": "Rango",
    "futures.community.trade": "Operación",
    "futures.community.trades": "Operaciones",
    "futures.community.favorite_asset": "Activo favorito",
    "futures.community.wager": "Apuesta",
    "futures.community.total_wagered": "Total apostado",
    "futures.community.biggest_win": "Mayor ganancia",
    "futures.community.total_profit": "Beneficio total",
    "futures.community.leverage": "Apalancamiento",
    "futures.community.entry": "Entrada",
    "futures.community.exit": "Salida",
    "futures.community.profit_loss": "Ganancia / Pérdida",
    "futures.community.profit": "Beneficio",
    "futures.community.multiplier": "Multiplicador",
    "futures.community.date": "Fecha",
    "futures.community.range": "Periodo",
    "futures.community.range.1d": "1D",
    "futures.community.range.1w": "1W",
    "futures.community.range.1m": "1M",
    "futures.community.range.all": "Todo el tiempo",
    "futures.tp_sl.column": "TP/SL",
    "futures.liquidation_price": "Precio de liquidación",
    "futures.mobile_trade.close": "Cerrar",
    "futures.mobile_trade.wager": "Apuesta",
    "futures.mobile_trade.place_trade": "Abrir operación",
    "futures.mobile_trade.placing": "Abriendo...",
    "futures.mobile_trade.fees_note": "Las comisiones de Binify varían según el apalancamiento utilizado. Para ver el desglose completo,",
    "futures.mobile_trade.fees_link": "haz clic aquí",
    "futures.mobile_trade.save_risk": "Guardar ajustes de riesgo",
    "futures.mobile_trade.wager_amount": "Monto de la apuesta",
    "futures.trade_form.wager_leverage": "Apuesta x apalancamiento",
    "futures.trade_form.risk_settings": "Ajustes de riesgo",
    "futures.trade_form.risk_mode": "Modo de valor de riesgo",
    "futures.trade_form.view_fees": "Ver comisiones de Binify",
    "futures.trade_modals.dont_ask_again": "No volver a preguntar",
    "futures.trade_modals.close": "Cerrar",
    "futures.cash_out.title": "¿Cerrar esta operación?",
    "futures.cash_out.text": "Una orden de mercado cerrará esta operación. La ganancia o pérdida resultante se reflejará en el saldo de tu cuenta.",
    "futures.cash_out.confirm": "Cerrar operación",
    "futures.close_all_modal.title": "¿Cerrar todas las operaciones abiertas?",
    "futures.close_all_modal.text": "Se colocarán órdenes de mercado para cerrar tus operaciones abiertas. Cualquier ganancia o pérdida resultante se reflejará en el saldo de tu cuenta.",
    "futures.close_all_modal.confirm": "Cerrar todas las operaciones",
    "futures.close_all_modal.cancel": "Mantener abiertas",
    "futures.partial_close_modal.title": "Cerrar operación",
    "futures.partial_close_modal.select_amount": "Selecciona el importe a cerrar",
    "futures.partial_close_modal.hint": "Confirma tu orden de venta a precio de mercado",
    "futures.partial_close_modal.wager_leverage": "Apuesta x apalancamiento",
    "futures.partial_close_modal.placed_on": "Abierta el",
    "futures.partial_close_modal.warning": "Confirma tu orden de venta a precio de mercado. Una vez confirmada, esta acción no se puede deshacer.",
    "futures.partial_close_modal.close_all": "Cerrar todo",
    "futures.partial_close_modal.too_small": "Este importe es demasiado pequeño para cerrar. Elige un porcentaje mayor o cierra la operación por completo.",
    "futures.fees_modal.open_fee": "Comisión de apertura",
    "futures.fees_modal.roi_fee": "Comisión ROI",
    "futures.fees_modal.open_description": "Una comisión del 1% que se cobra solo sobre tu apuesta, no sobre el total apalancado.",
    "futures.fees_modal.roi_description": "Elige tu apuesta, tu apalancamiento y cuánto se mueve el precio. Esto es lo que te llevas.",
    "futures.fees_modal.fee": "Comisión",
    "futures.fees_modal.wager_size": "Tamaño de la apuesta",
    "futures.fees_modal.profit_loss": "Ganancias y pérdidas",
    "futures.fees_modal.multi": "Multi",
    "futures.fees_modal.price_move": "Movimiento del precio",
    "futures.fees_modal.max_profit_for": "Ganancia máx. para",
    "futures.fees_modal.simple_title": "En pocas palabras",
    "futures.fees_modal.open_simple": "Binify ofrece una de las comisiones de apertura más bajas del sector. A diferencia de otras plataformas que cobran sobre toda la posición apalancada, Binify solo cobra sobre tu apuesta.",
    "futures.fees_modal.roi_simple": "El ROI en Binify depende de varios factores, como la clase de activo, el apalancamiento, la apuesta y el movimiento del precio. Cuanto más se mueva el precio a tu favor, mayor será tu rendimiento potencial.",
    "futures.fees_modal.got_it": "Entendido",
    "futures.trade_details.closed": "Cerrada",
    "futures.trade_details.direction": "Dirección",
    "futures.trade_details.time_held": "Tiempo abierta",
    "futures.trade_details.placed_by": "Abierta por",
    "futures.trade_details.trade_id": "ID de operación",
    "futures.trade_details.copy_id": "Copiar ID de operación",
    "futures.trade_details.share": "Compartir",
    "futures.trade_details.profit": "Ganancia",
    "futures.trade_details.up": "ARRIBA",
    "futures.trade_details.down": "ABAJO",
    "futures.trade_details.date": "Fecha",
    "futures.trade_details.demo_account": "Cuenta demo",
    "futures.trade_details.chart_no_data": "No hay datos del gráfico",
    "futures.trade_details.chart_error": "No se pudo cargar el gráfico",
    "futures.trade_details.chart_retry": "Reintentar",
    "futures.trader_profile.followers": "seguidores",
    "futures.trader_profile.trades": "Operaciones",
    "futures.trader_profile.stats": "Estadísticas",
    "futures.trader_profile.achievements": "Logros",
    "futures.trader_profile.win_rate": "% de aciertos",
    "futures.trader_profile.biggest_profit": "Mayor ganancia",
    "futures.trader_profile.favorite_asset": "Activo favorito",
    "futures.trader_profile.total_wagered": "Total apostado",
    "futures.trader_profile.total_closed_trades": "Operaciones cerradas",
    "futures.trader_profile.member_since": "Miembro desde",
    "futures.trader_profile.follow": "Seguir",
    "futures.toast.trade_opened": "Operación abierta",
    "futures.toast.trade_closed": "Operación cerrada",
    "futures.toast.bet_liquidated": "Operación liquidada",
    "futures.toast.your": "Tu operación",
    "futures.toast.is_live": "ya está activa",
    "futures.toast.closed_for": "se cerró con",
    "futures.toast.take_profit_hit": "Take Profit alcanzado",
    "futures.toast.stop_loss_hit": "Stop Loss alcanzado",
    "futures.toast.trade_partially_closed": "Operación cerrada parcialmente",
    "futures.toast.of_your": "de tu operación",
    "futures.toast.cashed_out": "Retiraste con éxito",
    "futures.toast.partial_ending": " ",
    "futures.trade_details.me": "Yo",
    "futures.trader_profile.no_trades": "Aún no hay operaciones",
    "futures.trade_details.opened": "Abierta",
    "futures.trader_profile.no_achievements": "Aún no hay logros",
  },

  ua: {
    "futures.chart.entry": "Вхід",
    "futures.chart.toolbar.chart_type": "Тип графіка",
    "futures.chart.toolbar.indicators": "Індикатори",
    "futures.chart.toolbar.drawings": "Малювання",
    "futures.chart.toolbar.more": "Більше",
    "futures.chart.toolbar.timezone_settings": "Налаштування часового поясу",
    "futures.chart.more_menu.pl_lines": "Лінії P&L",
    "futures.chart.type_menu.chart_types": "Типи графіків",
    "futures.chart.type_menu.time_frames": "Таймфрейми",
    "futures.chart.type_menu.settings": "Налаштування",
    "futures.chart.type_menu.enable_timer": "Увімкнути таймер",
    "futures.chart.type_menu.enable_autoscroll": "Увімкнути автопрокрутку",
    "futures.chart.type_menu.enable_grid_snap": "Прив'язка до сітки",
    "futures.chart.type_menu.custom_candle_colors": "Кольори свічок",
    "futures.chart.candle_colors.title": "Кольори свічок",
    "futures.chart.candle_colors.close": "Закрити",
    "futures.chart.candle_colors.uptrend": "Колір зростання",
    "futures.chart.candle_colors.downtrend": "Колір падіння",
    "futures.chart.candle_colors.use_default": "Кольори за замовчуванням",
    "futures.chart.candle_colors.apply": "Застосувати",
    "futures.chart.candle_colors.shadow_style": "Стиль тіней",
    "futures.chart.candle_colors.shadow_regular": "Звичайний",
    "futures.chart.candle_colors.shadow_thick": "Товстий",
    "futures.chart.type.line": "Лінія",
    "futures.chart.type.candles": "Свічки",
    "futures.chart.type.bars": "Бари",
    "futures.chart.type.heikin_ashi": "Хейкен Аші",
    "futures.chart.ohlc.open": "Відкриття",
    "futures.chart.ohlc.close": "Закриття",
    "futures.chart.ohlc.high": "Максимум",
    "futures.chart.ohlc.low": "Мінімум",
    "futures.chart.zoom.visible_range": "Видимий період",
    "futures.chart.resize": "Потягніть, щоб змінити висоту",
    "futures.chart.scroll_to_end": "До останньої свічки",
    "futures.chart.timezone.title": "Часовий пояс",
    "futures.chart.timezone.description": "Часовий пояс вашого профілю: за ним показуються графік, годинник і весь час на платформі.",
    "futures.chart.timezone.your_location": "Ваше розташування",
    "futures.chart.timezone.search": "Пошук",
    "futures.chart.timezone.not_found": "Нічого не знайдено",
    "futures.chart.timezone.close": "Закрити",
    "futures.chart.indicators.tab_current": "Поточні",
    "futures.chart.indicators.tab_all": "Усі",
    "futures.chart.indicators.tab_favorites": "Обрані",
    "futures.chart.indicators.delete_all": "Видалити все ({count})",
    "futures.chart.indicators.add_favorite": "Додати в обране",
    "futures.chart.indicators.remove_favorite": "Прибрати з обраного",
    "futures.chart.indicators.remove": "Видалити",
    "futures.chart.indicators.hide": "Сховати",
    "futures.chart.indicators.show": "Показати",
    "futures.chart.indicators.settings": "Налаштування",
    "futures.chart.indicators.legend_collapse": "Згорнути індикатори",
    "futures.chart.indicators.legend_expand": "Показати індикатори",
    "futures.chart.indicators.header_hide": "Сховати заголовок",
    "futures.chart.indicators.header_show": "Показати заголовок",
    "futures.chart.indicators.pane_expand": "Розгорнути",
    "futures.chart.indicators.pane_restore": "Звичайний розмір",
    "futures.chart.drawings.tab_current": "Поточні",
    "futures.chart.drawings.tab_all": "Усі",
    "futures.chart.drawings.delete_all": "Видалити все ({count})",
    "futures.chart.drawings.remove": "Видалити",
    "futures.chart.drawings.tool_horizontal_line": "Горизонтальна лінія",
    "futures.chart.drawings.tool_vertical_line": "Вертикальна лінія",
    "futures.chart.drawings.tool_ray": "Промінь",
    "futures.chart.drawings.tool_trend_line": "Трендова лінія",
    "futures.chart.drawings.tool_rectangle": "Прямокутник",
    "futures.chart.drawings.tool_fibonacci_retracement": "Корекція Фібоначчі",
    "futures.chart.drawings.tool_fibonacci_fan": "Віяло Фібоначчі",
    "futures.chart.drawings.tool_parallel_channel": "Паралельний канал",
    "futures.chart.drawings.tool_andrews_pitchfork": "Вила Ендрюса",
    "futures.chart.drawing_toolbar.label": "Панель малюнка",
    "futures.chart.drawing_toolbar.move": "Перемістити панель",
    "futures.chart.drawing_toolbar.clone": "Клонувати",
    "futures.chart.drawing_toolbar.settings": "Налаштування",
    "futures.chart.drawing_toolbar.lock": "Заблокувати",
    "futures.chart.drawing_toolbar.unlock": "Розблокувати",
    "futures.chart.indicator_settings.close": "Закрити",
    "futures.chart.indicator_settings.tab_inputs": "Параметри",
    "futures.chart.indicator_settings.tab_styles": "Стиль",
    "futures.chart.indicator_settings.remove": "Видалити",
    "futures.chart.indicator_settings.cancel": "Скасувати",
    "futures.chart.indicator_settings.save": "Зберегти",
    "futures.chart.indicator_settings.line_color": "Колір лінії",
    "futures.chart.indicator_settings.line_width": "Товщина лінії",
    "futures.chart.indicator_settings.line_style": "Колір і товщина лінії",
    "futures.chart.indicator_settings.show": "Показати",
    "futures.chart.indicator_settings.level": "Рівень",
    "futures.chart.indicator_settings.down_color": "падіння",
    "futures.no-data": "Немає активних операцій",
    "futures.no-data.desc": "Зробіть операцію, щоб побачити її тут.",
    "futures.order_book": "Книга ордерів",
    "futures.price": "Ціна",
    "futures.size": "Обсяг",
    "futures.total": "Всього",
    "futures.cost": "Вартість",
    "futures.isolated": "Ізольований",
    "futures.limit": "Ліміт",
    "futures.market": "Ринок",
    "futures.instrument": "Інструмент",
    "futures.order-type": "Тип ордера",
    "futures.order-price": "Ціна ордера",
    "futures.avg_filled_price": "Сер. ціна виконання",
    "futures.avg_filled_price-short": "Сер. ціна",
    "futures.status-filled": "Виконано",
    "futures.status-cancelled": "Скасовано",
    "futures.order-quantity": "Виконано/Кількість",
    "futures.order-type-short": "Тип",
    "futures.order-price-short": "Ціна",
    "futures.order-value-short": "Вартість",
    "futures.order-quantity-short": "Вик./К-сть",
    "futures.order-value": "Вартість ордера",
    "futures.order-id": "ID ордера",
    "futures.reduce-only": "Тільки зменшення",
    "futures.order-action": "Дія",
    "futures.available_balance": "Доступний баланс",
    "futures.long": "Лонг",
    "futures.short": "Шорт",
    "futures.open-long": "Long",
    "futures.open-short": "Short",
    "futures.liq_price": "Ціна ліквідації",
    "futures.quantity": "Кількість",
    "futures.max": "Макс",
    "futures.adjust_leverage": "Налаштувати кредитне плече",
    "futures.leverage": "Кредитне плече",
    "futures.leverage_warn":
      "* Вибір більшого кредитного плеча, наприклад [10x], збільшує ризик вашої ліквідації.\n" +
      "              Завжди керуйте своїм рівнем ризику. Дивіться нашу статтю довідки для\n" +
      "              додаткової інформації.",

    "futures.positions": "Позиції",
    "futures.open_orders": "Відкриті ордери",
    "futures.order_history": "Історія ордерів",
    "futures.position_history": "Історія позицій",
    "futures.open_trades": "Відкриті угоди",
    "futures.closed_trades": "Закриті угоди",
    "futures.symbol": "Символ",
    "futures.side": "Сторона",
    "futures.entry_price": "Ціна входу",
    "futures.exit_price": "Ціна виходу",
    "futures.margin": "Маржа",
    "futures.pnl_roi": "PnL (ROI %)",
    "futures.close_all_positions": "Закрити всі позиції",
    "futures.perp": "Perp",
    "futures.close": "Закрити",
    "futures.add": "Додати",
    "futures.share": "Поділитися P&L",
    "futures.copy": "Скопіювати",
    "futures.save": "Зберегти",
    "futures.buy": "Купити",
    "futures.sell": "Продати",
    "futures.modal.buy": "Купівля",
    "futures.modal.sell": "Продаж",
    "futures.email": "Пошта",
    "futures.telegram": "Телеграм",
    "futures.more": "Більше",
    "futures.perpetual": "Безстрокові",
    "futures.time": "Час",
    "futures.type": "Тип",
    "futures.amount": "Сума",
    "futures.cancel_all": "Скасувати все",
    "futures.cancel": "Скасувати",
    "futures.executed": "Виконано",
    "futures.status": "Статус",
    "futures.closing_pnl": "PnL при закритті",
    "futures.pair": "Пара",
    "futures.close_price": "Ціна закриття",
    "futures.opened": "Відкрито",
    "futures.closed": "Закрито",
    "futures.contracts": "Контракти",
    "futures.unrealized_pnl": "Нереалізований P&L (ROI)",
    "futures.unrealized_pnl_short": "Нереал. PNL (ROI)",
    "futures.realized_pnl": "Реалізований P&L (ROI)",
    "futures.value": "Значення",
    "futures.settings": "Налаштування TP/SL",
    "futures.direction": "Напрямок",
    "futures.direction_short": "Напр.",
    "futures.quality": "Кількість",
    "futures.order_time": "Час відкриття",
    "futures.order_time-short": "Відкрито",
    "futures.close_time": "Час закриття",
    "futures.realized": "Реалізований P&L",
    "futures.fees": "Комісії",
    "futures.details": "Деталі",
    "futures.hide_other_symbols": "Приховати інші символи",
    "futures.order_opened": "Ордер відкрито",
    "futures.order_success": "Ваш ордер успішно розміщено!",
    "futures.position_opened": "Позицію відкрито",
    "futures.position_success": "Вашу позицію успішно відкрито!",
    "futures.order_closed": "Ордер закрито",
    "futures.order_close_success": "Ваш ордер було успішно закрито!",
    "futures.position_closed": "Позицію закрито",
    "futures.position_close_success": "Вашу позицію було успішно закрито!",
    "futures.change_24h": "Зміна за 24 год",
    "futures.open_profit_loss": "Відкритий прибуток/збиток",
    "futures.mark_price": "Маркерна ціна",
    "futures.high_24h": "Макс за 24 год",
    "futures.low_24h": "Мін за 24 год",
    "futures.quantity_24h": "Обсяг за 24 год (USDT)",
    "futures.total_24h": "Всього за 24 год",
    "futures.chart": "Графік",
    "futures.tp_sl.advanced": "Розширені",
    "futures.tp_sl.take_profit": "Тейк-профіт",
    "futures.tp_sl.stop_loss": "Стоп-лос",
    "futures.tp_sl.trigger_price": "Ціна спрацювання",
    "futures.tp_sl.pnl": "Прибуток / Збиток",
    "futures.tp_sl.short_label": "Приховати інші символи",

    "futures.tp_sl.tp_description":
      "Коли ринкова ціна досягне {price} USDT, буде створено лімітний ордер, а очікуваний PnL становитиме {pnl} USDT (ROI: {roi}%).",

    "futures.tp_sl.sl_description":
      "Коли ринкова ціна досягне {price} USDT, буде створено ринковий ордер, а очікуваний PnL становитиме {pnl} USDT (ROI: {roi}%).",

    "futures.share.description": ["Торгуй", "як професіонал з", "Binify"],
    "futures.share.default_trader": "Трейдер Binify",
    "futures.entire_position": "Уся позиція",
    "futures.partial_position": "Часткова позиція",
    "futures.add_tp_sl": "Додати TP/SL",
    "futures.last_traded_price": "Остання ціна угоди",
    "futures.tp_by_roi": "TP (за ROI)",
    "futures.sl_by_roi": "SL (за ROI)",
    "futures.market_price": "Ринкова ціна",
    "futures.limit_price": "Лімітна ціна",
    "futures.slippage_limit": "Ліміт прослизання",
    "futures.best_bid_ask": "Найкращий Bid/Ask",
    "futures.close_size_quantity": "Розмір закриття (Кількість)",
    "futures.size_percentage": "Відсоток розміру",
    "futures.exit_at_market": "Вихід по ринку",
    "futures.buy_profit": "Прибуток по лонгу",
    "futures.sell_profit": "Прибуток по шорту",

    "futures.validation.invalid_cost": "Вартість має бути більшою за 0",
    "futures.validation.cost_required": "Будь ласка, введіть вартість",
    "futures.validation.cost_min": "Мінімальна вартість - {min}",
    "futures.validation.wager_min": "Мінімальна ставка {min}",
    "futures.validation.insufficient_balance": "Недостатньо коштів",
    "futures.new_validation_tp_sl.error_title": "Помилка розміщення угоди",
    "futures.new_validation_tp_sl.sl_over_limit_percent": "Стоп-лосс не може перевищувати 100% від суми ставки",
    "futures.new_validation_tp_sl.sl_over_limit_dollar": "Стоп-лосс не може перевищувати суму ставки",
    "futures.new_validation_tp_sl.tp_out_of_range": "Тейк-профіт має бути між {min} і {max}",

    "futures.onboarding.closeLabel": "Закрити онбординг",
    "futures.onboarding.step1.title": "Налаштування акаунта",
    "futures.onboarding.step1.description":
      "Оберіть країну / регіон і бажану мову платформи, щоб продовжити.",
    "futures.onboarding.step1.countryLabel": "Країна / Регіон",
    "futures.onboarding.step1.countryValue": "Україна",
    "futures.onboarding.step1.languageLabel": "Мова платформи",
    "futures.onboarding.step1.countryPlaceholder": "Оберіть свою країну",
    "futures.onboarding.step1.languageValue": "Українська",
    "futures.onboarding.step1.note":
      "Ви можете змінити ці налаштування пізніше у своєму профілі.",
    "futures.onboarding.step1.confirm": "Підтвердити",
    "futures.onboarding.step2.back": "Назад",
    "futures.onboarding.step2.title": "Успіхів у торгівлі!",
    "futures.onboarding.step2.description":
      "Усе, що потрібно для успішного старту торгівлі на",
    "futures.onboarding.step2.guideTitle": "Ознайомтеся зі вступним гайдом",
    "futures.onboarding.step2.guideDescription":
      "Вивчіть основи та почніть упевнено.",
    "futures.onboarding.step2.tutorial": "Навчання",
    "futures.onboarding.step2.depositTitle":
      "Інвестиція для реального прибутку",
    "futures.onboarding.step2.depositDescription":
      "Поповніть акаунт і почніть торгувати за кілька хвилин.",
    "futures.onboarding.step2.depositButton": "Поповнити",
    "futures.onboarding.step2.startTitle": "Перейти на платформу прямо зараз!",
    "futures.onboarding.step2.startDescription":
      "Ознайомтеся з платформою та почніть торгувати.",
    "futures.onboarding.step2.startButton": "Почати",
    "futures.onboarding.step2.footer":
      "Готові торгувати розумніше. Торгуйте на",

    "futures.onboarding.trading_chart.title": "Торговий графік",
    "futures.onboarding.trading_chart.description":
      "Графік показує зміну ціни активу в реальному часі. Використовуйте його для аналізу ринку та пошуку торгових можливостей.",
    "futures.onboarding.asset_selection.title": "Вибір активу",
    "futures.onboarding.asset_selection.description":
      "Оберіть актив, яким хочете торгувати, зі списку доступних ринків.",
    "futures.onboarding.available_assets.title": "Доступні активи",
    "futures.onboarding.available_assets.description":
      "Перегляньте всі доступні торгові пари та оберіть актив для торгівлі.",
    "futures.onboarding.trading_panel.title": "Торгова панель",
    "futures.onboarding.trading_panel.description":
      "Тут ви можете створювати та керувати своїми угодами.",
    "futures.onboarding.trading_panel_details.description":
      "Налаштуйте тип ордера, ціну, суму, кредитне плече та параметри TP/SL перед відкриттям позиції.",
    "futures.onboarding.limit_order.title": "Тип ордера",
    "futures.onboarding.limit_order.description":
      "Лімітний ордер буде розміщений у відкритих ордерах і виконається лише після досягнення вибраної ціни.",
    "futures.onboarding.market_order.title": "Тип ордера",
    "futures.onboarding.market_order.description":
      "Ринковий ордер відкривається миттєво за поточною ринковою ціною.",
    "futures.onboarding.position_size.title": "Розмір позиції",
    "futures.onboarding.position_size.description":
      "Вкажіть суму, яку хочете використати для своєї угоди.",
    "futures.onboarding.leverage.title": "Кредитне плече",
    "futures.onboarding.leverage.description":
      "Кредитне плече дозволяє відкривати більші позиції, використовуючи меншу маржу.",
    "futures.onboarding.take_profit_stop_loss.title": "Тейк-профіт та Стоп-лос",
    "futures.onboarding.take_profit_stop_loss.description":
      "Встановіть цільовий прибуток і максимальний рівень збитку для автоматичного керування позицією.",
    "futures.onboarding.open_position.title": "Відкриття позиції",
    "futures.onboarding.open_position.description":
      "Long приносить прибуток при зростанні ціни. Short приносить прибуток при падінні ціни. Оберіть напрямок і відкрийте свою позицію.",
    "futures.onboarding.open_orders.title": "Відкриті ордери",
    "futures.onboarding.open_orders.description":
      "Відкриті ордери — це ордери, які очікують на виконання.",
    "futures.onboarding.position_opened.title": "Позицію відкрито",
    "futures.onboarding.position_opened.description":
      "Ваша позиція активна. Відстежуйте PnL, ціну входу, розмір позиції та ціну ліквідації у розділі Позиції.",
    "futures.onboarding.positions.title": "Позиції",
    "futures.onboarding.positions.description":
      "Позиції — це всі активні відкриті позиції.",
    "futures.onboarding.order_history.title": "Історія ордерів",
    "futures.onboarding.order_history.description":
      "Історія ордерів — усі створені та виконані ордери.",
    "futures.onboarding.position_history.title": "Історія позицій",
    "futures.onboarding.position_history.description":
      "Історія позицій — усі закриті позиції та результати їх виконання.",
    "futures.onboarding.manage_position.title": "Керування позицією",
    "futures.onboarding.manage_position.description":
      "Ви можете змінювати налаштування Тейк-профіту та Стоп-лосу або закрити позицію в будь-який момент.",

    "futures.all_markets": "Усі ринки",
    "futures.all_instruments": "Усі інструменти",
    "futures.close_all": "Закрити все",
    "futures.spot_only": "Тільки спот",
    "futures.perpetual_only": "Тільки безстрокові",
    "futures.expired_only": "Тільки експіровані",
    "futures.customization": "Налаштування",
    "futures.actions": "Дії",
    "futures.liquidation": "Ліквідація",
    "futures.partial_close": "Часткове закриття",
    "futures.instrument_filter": "Фільтр інструментів",
    "futures.my_position": "Мої позиції",
    "futures.community": "Спільнота",
    "futures.community.public_feed": "Публічна стрічка",
    "futures.community.leaderboard": "Рейтинг",
    "futures.community.best_trades": "Найкращі угоди",
    "futures.community.username": "Ім'я користувача",
    "futures.community.user": "Користувач",
    "futures.community.rank": "Ранг",
    "futures.community.trade": "Угода",
    "futures.community.trades": "Угоди",
    "futures.community.favorite_asset": "Улюблений актив",
    "futures.community.wager": "Ставка",
    "futures.community.total_wagered": "Всього поставлено",
    "futures.community.biggest_win": "Найбільший виграш",
    "futures.community.total_profit": "Загальний прибуток",
    "futures.community.leverage": "Плече",
    "futures.community.entry": "Вхід",
    "futures.community.exit": "Вихід",
    "futures.community.profit_loss": "Прибуток / Збиток",
    "futures.community.profit": "Прибуток",
    "futures.community.multiplier": "Множник",
    "futures.community.date": "Дата",
    "futures.community.range": "Період",
    "futures.community.range.1d": "1D",
    "futures.community.range.1w": "1W",
    "futures.community.range.1m": "1M",
    "futures.community.range.all": "Весь час",
    "futures.tp_sl.column": "TP/SL",
    "futures.liquidation_price": "Ціна ліквідації",
    "futures.mobile_trade.close": "Закрити",
    "futures.mobile_trade.wager": "Ставка",
    "futures.mobile_trade.place_trade": "Відкрити угоду",
    "futures.mobile_trade.placing": "Відкриття...",
    "futures.mobile_trade.fees_note": "Комісії Binify залежать від використаного кредитного плеча. Детальніше —",
    "futures.mobile_trade.fees_link": "натисніть тут",
    "futures.mobile_trade.save_risk": "Зберігати налаштування ризику",
    "futures.mobile_trade.wager_amount": "Сума ставки",
    "futures.trade_form.wager_leverage": "Ставка x плече",
    "futures.trade_form.risk_settings": "Налаштування ризику",
    "futures.trade_form.risk_mode": "Режим значення ризику",
    "futures.trade_form.view_fees": "Переглянути комісії Binify",
    "futures.trade_modals.dont_ask_again": "Більше не питати",
    "futures.trade_modals.close": "Закрити",
    "futures.cash_out.title": "Закрити цю угоду?",
    "futures.cash_out.text": "Угоду буде закрито ринковим ордером. Отриманий прибуток або збиток відобразиться на балансі вашого рахунку.",
    "futures.cash_out.confirm": "Закрити угоду",
    "futures.close_all_modal.title": "Закрити всі відкриті угоди?",
    "futures.close_all_modal.text": "Відкриті угоди буде закрито ринковими ордерами. Отриманий прибуток або збиток відобразиться на балансі вашого рахунку.",
    "futures.close_all_modal.confirm": "Закрити всі угоди",
    "futures.close_all_modal.cancel": "Залишити відкритими",
    "futures.partial_close_modal.title": "Закрити угоду",
    "futures.partial_close_modal.select_amount": "Оберіть суму для закриття",
    "futures.partial_close_modal.hint": "Підтвердьте ордер на продаж за ринковою ціною",
    "futures.partial_close_modal.wager_leverage": "Ставка x плече",
    "futures.partial_close_modal.placed_on": "Відкрито",
    "futures.partial_close_modal.warning": "Підтвердьте ордер на продаж за ринковою ціною. Після підтвердження цю дію не можна скасувати.",
    "futures.partial_close_modal.close_all": "Закрити все",
    "futures.partial_close_modal.too_small": "Ця сума занадто мала для закриття. Оберіть більший відсоток або закрийте угоду повністю.",
    "futures.fees_modal.open_fee": "Комісія за відкриття",
    "futures.fees_modal.roi_fee": "Комісія ROI",
    "futures.fees_modal.open_description": "Комісія 1% стягується лише із суми ставки, а не з усієї суми з плечем.",
    "futures.fees_modal.roi_description": "Вкажіть ставку, плече і зміну ціни. Ось скільки ви отримаєте.",
    "futures.fees_modal.fee": "Комісія",
    "futures.fees_modal.wager_size": "Розмір ставки",
    "futures.fees_modal.profit_loss": "Прибуток і збиток",
    "futures.fees_modal.multi": "Множник",
    "futures.fees_modal.price_move": "Зміна ціни",
    "futures.fees_modal.max_profit_for": "Макс. прибуток для",
    "futures.fees_modal.simple_title": "Простими словами",
    "futures.fees_modal.open_simple": "У Binify одна з найнижчих комісій за відкриття в індустрії. На відміну від інших платформ, які беруть комісію з усієї позиції з плечем, Binify бере її лише із суми ставки.",
    "futures.fees_modal.roi_simple": "ROI на Binify залежить від кількох чинників: класу активу, плеча, суми ставки та зміни ціни. Що сильніше ціна рухається на вашу користь, то вищий потенційний дохід.",
    "futures.fees_modal.got_it": "Зрозуміло",
    "futures.trade_details.closed": "Закрита",
    "futures.trade_details.direction": "Напрямок",
    "futures.trade_details.time_held": "Час утримання",
    "futures.trade_details.placed_by": "Відкрив",
    "futures.trade_details.trade_id": "ID угоди",
    "futures.trade_details.copy_id": "Скопіювати ID угоди",
    "futures.trade_details.share": "Поділитися",
    "futures.trade_details.profit": "Прибуток",
    "futures.trade_details.up": "ВГОРУ",
    "futures.trade_details.down": "ВНИЗ",
    "futures.trade_details.date": "Дата",
    "futures.trade_details.demo_account": "Демо-рахунок",
    "futures.trade_details.chart_no_data": "Немає даних для графіка",
    "futures.trade_details.chart_error": "Не вдалося завантажити графік",
    "futures.trade_details.chart_retry": "Повторити",
    "futures.trader_profile.followers": "підписників",
    "futures.trader_profile.trades": "Угоди",
    "futures.trader_profile.stats": "Статистика",
    "futures.trader_profile.achievements": "Досягнення",
    "futures.trader_profile.win_rate": "Перемог %",
    "futures.trader_profile.biggest_profit": "Найбільший прибуток",
    "futures.trader_profile.favorite_asset": "Улюблений актив",
    "futures.trader_profile.total_wagered": "Усього поставлено",
    "futures.trader_profile.total_closed_trades": "Закритих угод",
    "futures.trader_profile.member_since": "З нами з",
    "futures.trader_profile.follow": "Підписатися",
    "futures.toast.trade_opened": "Угоду відкрито",
    "futures.toast.trade_closed": "Угоду закрито",
    "futures.toast.bet_liquidated": "Угоду ліквідовано",
    "futures.toast.your": "Ваша угода",
    "futures.toast.is_live": "відкрита",
    "futures.toast.closed_for": "закрита з результатом",
    "futures.toast.take_profit_hit": "Спрацював тейк-профіт",
    "futures.toast.stop_loss_hit": "Спрацював стоп-лос",
    "futures.toast.trade_partially_closed": "Угоду частково закрито",
    "futures.toast.of_your": "вашої угоди",
    "futures.toast.cashed_out": "Ви успішно вивели",
    "futures.toast.partial_ending": " ",
    "futures.trade_details.me": "Я",
    "futures.trader_profile.no_trades": "Поки немає угод",
    "futures.trade_details.opened": "Відкрита",
    "futures.trader_profile.no_achievements": "Поки немає досягнень",
  },
};

export default futures;
